/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.11.1.0 (NJsonSchema v10.4.3.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export interface IConfig {
  getAccessToken: () => string;
}

export class AuthorizedApiBase {
  private readonly config: IConfig;

  protected constructor(config: IConfig) {
    this.config = config;
  }

  protected transformOptions = (options: RequestInit): Promise<RequestInit> => {
    options.headers = {
      ...options.headers,
      Authorization: `Bearer ${this.config.getAccessToken()}`,
    };
    return Promise.resolve(options);
  };
}

export class ApiClient extends AuthorizedApiBase {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    configuration: IConfig,
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> },
  ) {
    super(configuration);
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * Get access control groups for tenant
   * @param page (optional) pagination page
   * @param pageSize (optional) pagination pageSize
   * @param searchString (optional) pagination searchString
   * @param tenantExternalId (optional) tenant unique name, e.g. Livly
   * @param propertyExternalId (optional) propertyExternalId (e.g. Livly propertyCode)
   * @return Success
   */
  getAccessControlGroups(
    page: number | undefined,
    pageSize: number | undefined,
    searchString: string | undefined,
    tenantExternalId: string | undefined,
    propertyExternalId: string | undefined,
  ): Promise<AccessControlGroupResponse[]> {
    let url_ = this.baseUrl + "/api/AccessControlGroups?";
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (searchString === null)
      throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined)
      url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
    if (tenantExternalId === null)
      throw new Error("The parameter 'tenantExternalId' cannot be null.");
    else if (tenantExternalId !== undefined)
      url_ +=
        "tenantExternalId=" + encodeURIComponent("" + tenantExternalId) + "&";
    if (propertyExternalId === null)
      throw new Error("The parameter 'propertyExternalId' cannot be null.");
    else if (propertyExternalId !== undefined)
      url_ +=
        "propertyExternalId=" +
        encodeURIComponent("" + propertyExternalId) +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAccessControlGroups(_response);
      });
  }

  protected processGetAccessControlGroups(
    response: Response,
  ): Promise<AccessControlGroupResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <AccessControlGroupResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<AccessControlGroupResponse[]>(<any>null);
  }

  /**
   * Create access control group
   * @param body (optional) access control group info
   * @return Success
   */
  postAccessControlGroup(
    body: RegisterAccessControlGroupRequest | undefined,
  ): Promise<AccessControlGroupResponse> {
    let url_ = this.baseUrl + "/api/AccessControlGroups";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPostAccessControlGroup(_response);
      });
  }

  protected processPostAccessControlGroup(
    response: Response,
  ): Promise<AccessControlGroupResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <AccessControlGroupResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<AccessControlGroupResponse>(<any>null);
  }

  /**
   * Get locks for access control group
   * @param id id of group
   * @param page (optional) pagination page
   * @param pageSize (optional) pagination pageSize
   * @param searchString (optional) pagination searchString
   * @return Success
   */
  getLocksForAccessControlGroup(
    id: string,
    page: number | undefined,
    pageSize: number | undefined,
    searchString: string | undefined,
  ): Promise<AccessControlGroupLockResponse[]> {
    let url_ =
      this.baseUrl + "/api/AccessControlGroups/accessControlGroupLocks/{id}?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (searchString === null)
      throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined)
      url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetLocksForAccessControlGroup(_response);
      });
  }

  protected processGetLocksForAccessControlGroup(
    response: Response,
  ): Promise<AccessControlGroupLockResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <AccessControlGroupLockResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<AccessControlGroupLockResponse[]>(<any>null);
  }

  /**
   * Add lock to group
   * @param id id of group
   * @param body (optional) access control group info
   * @return Success
   */
  addLockToAccessControlGroup(
    id: string,
    body: LockMapInfo | undefined,
  ): Promise<RegisterAccountResponse> {
    let url_ = this.baseUrl + "/api/AccessControlGroups/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "PATCH",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAddLockToAccessControlGroup(_response);
      });
  }

  protected processAddLockToAccessControlGroup(
    response: Response,
  ): Promise<RegisterAccountResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <RegisterAccountResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<RegisterAccountResponse>(<any>null);
  }

  /**
   * Delete access control group
   * @param id id of access control group
   * @return Success
   */
  deleteAccessControlGroup(id: string): Promise<void> {
    let url_ = this.baseUrl + "/api/AccessControlGroups/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "DELETE",
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteAccessControlGroup(_response);
      });
  }

  protected processDeleteAccessControlGroup(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param tenantExternalId (optional)
   * @return Success
   */
  getAccessControlGroup(
    id: string,
    tenantExternalId: string | undefined,
  ): Promise<AccessControlGroupResponse> {
    let url_ = this.baseUrl + "/api/AccessControlGroups/{id}?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (tenantExternalId === null)
      throw new Error("The parameter 'tenantExternalId' cannot be null.");
    else if (tenantExternalId !== undefined)
      url_ +=
        "tenantExternalId=" + encodeURIComponent("" + tenantExternalId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAccessControlGroup(_response);
      });
  }

  protected processGetAccessControlGroup(
    response: Response,
  ): Promise<AccessControlGroupResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <AccessControlGroupResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<AccessControlGroupResponse>(<any>null);
  }

  /**
   * Delete lock from group
   * @param accessControlGroupId id of group
   * @param lockId access control group info
   * @return Success
   */
  deleteLockFromAccessControlGroup(
    accessControlGroupId: string,
    lockId: string,
  ): Promise<RegisterAccountResponse> {
    let url_ =
      this.baseUrl +
      "/api/AccessControlGroups/locks/{accessControlGroupId}/{lockId}";
    if (accessControlGroupId === undefined || accessControlGroupId === null)
      throw new Error("The parameter 'accessControlGroupId' must be defined.");
    url_ = url_.replace(
      "{accessControlGroupId}",
      encodeURIComponent("" + accessControlGroupId),
    );
    if (lockId === undefined || lockId === null)
      throw new Error("The parameter 'lockId' must be defined.");
    url_ = url_.replace("{lockId}", encodeURIComponent("" + lockId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "DELETE",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteLockFromAccessControlGroup(_response);
      });
  }

  protected processDeleteLockFromAccessControlGroup(
    response: Response,
  ): Promise<RegisterAccountResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <RegisterAccountResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<RegisterAccountResponse>(<any>null);
  }

  /**
   * Associate access control group and tenant
   * @param id access control group id
   * @param tenantId tenant id
   * @return Success
   */
  addAcgToTenant(
    id: string,
    tenantId: string,
  ): Promise<RegisterAccountResponse> {
    let url_ = this.baseUrl + "/api/AccessControlGroups/{id}/{tenantId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (tenantId === undefined || tenantId === null)
      throw new Error("The parameter 'tenantId' must be defined.");
    url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAddAcgToTenant(_response);
      });
  }

  protected processAddAcgToTenant(
    response: Response,
  ): Promise<RegisterAccountResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <RegisterAccountResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<RegisterAccountResponse>(<any>null);
  }

  /**
   * Create access control group
   * @param body (optional) access control group info
   * @return Success
   */
  patchAccessControlGroup(
    id: string,
    body: UpdateAccessControlGroupRequest | undefined,
  ): Promise<AccessControlGroupResponse> {
    let url_ = this.baseUrl + "/api/AccessControlGroups/{id}/info";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "PATCH",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPatchAccessControlGroup(_response);
      });
  }

  protected processPatchAccessControlGroup(
    response: Response,
  ): Promise<AccessControlGroupResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <AccessControlGroupResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<AccessControlGroupResponse>(<any>null);
  }

  /**
   * Sets schedules on an access control group
   * @param body (optional)
   * @return Success
   */
  putAccessControlGroupSchedules(
    id: string,
    body: string[] | undefined,
  ): Promise<number> {
    let url_ = this.baseUrl + "/api/AccessControlGroups/{id}/schedules";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPutAccessControlGroupSchedules(_response);
      });
  }

  protected processPutAccessControlGroupSchedules(
    response: Response,
  ): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <number>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<number>(<any>null);
  }

  /**
   * Get accounts for logged-in tenant
   * @param page (optional) pagination page
   * @param pageSize (optional) pagination pageSize
   * @param searchString (optional) pagination searchString
   * @param tenantExternalId (optional) tenant unique name, e.g. Livly
   * @return Success
   */
  getAccounts(
    page: number | undefined,
    pageSize: number | undefined,
    searchString: string | undefined,
    tenantExternalId: string | undefined,
  ): Promise<AccountResponse[]> {
    let url_ = this.baseUrl + "/api/Accounts?";
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (searchString === null)
      throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined)
      url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
    if (tenantExternalId === null)
      throw new Error("The parameter 'tenantExternalId' cannot be null.");
    else if (tenantExternalId !== undefined)
      url_ +=
        "tenantExternalId=" + encodeURIComponent("" + tenantExternalId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAccounts(_response);
      });
  }

  protected processGetAccounts(response: Response): Promise<AccountResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <AccountResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<AccountResponse[]>(<any>null);
  }

  /**
   * Create an account
   * @param body (optional) account info
   * @return Success
   */
  postAccount(
    body: RegisterAccountRequest | undefined,
  ): Promise<RegisterAccountResponse> {
    let url_ = this.baseUrl + "/api/Accounts";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPostAccount(_response);
      });
  }

  protected processPostAccount(
    response: Response,
  ): Promise<RegisterAccountResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <RegisterAccountResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<RegisterAccountResponse>(<any>null);
  }

  /**
   * Get accounts for logged-in tenant by system type
   * @param tenantExternalId (optional) tenant unique name, e.g. Livly
   * @return Success
   */
  getAccountWithCredentialsById(
    tenantExternalId: string | undefined,
    id: string,
  ): Promise<AccountWithCredentialsResponse> {
    let url_ = this.baseUrl + "/api/Accounts/{id}?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (tenantExternalId === null)
      throw new Error("The parameter 'tenantExternalId' cannot be null.");
    else if (tenantExternalId !== undefined)
      url_ +=
        "tenantExternalId=" + encodeURIComponent("" + tenantExternalId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAccountWithCredentialsById(_response);
      });
  }

  protected processGetAccountWithCredentialsById(
    response: Response,
  ): Promise<AccountWithCredentialsResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <AccountWithCredentialsResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<AccountWithCredentialsResponse>(<any>null);
  }

  /**
   * Delete an account
   * @param id id of account
   * @return Success
   */
  deleteAccount(id: string): Promise<void> {
    let url_ = this.baseUrl + "/api/Accounts/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "DELETE",
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteAccount(_response);
      });
  }

  protected processDeleteAccount(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Create an account with shared credentials
   * @param body (optional) account info
   * @return Success
   */
  postAccountWithSharedCredentials(
    body: RegisterAccountWithSharedCredentialsRequest | undefined,
  ): Promise<RegisterAccountResponse> {
    let url_ = this.baseUrl + "/api/Accounts/sharedCred";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPostAccountWithSharedCredentials(_response);
      });
  }

  protected processPostAccountWithSharedCredentials(
    response: Response,
  ): Promise<RegisterAccountResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <RegisterAccountResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<RegisterAccountResponse>(<any>null);
  }

  /**
   * Get all mapped locks in the system
   * @param page (optional) pagination page
   * @param pageSize (optional) pagination pageSize
   * @param searchString (optional) pagination searchString
   * @return Success
   */
  getAdminLocks(
    page: number | undefined,
    pageSize: number | undefined,
    searchString: string | undefined,
  ): Promise<LockResponse[]> {
    let url_ = this.baseUrl + "/api/Admin/locks?";
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (searchString === null)
      throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined)
      url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAdminLocks(_response);
      });
  }

  protected processGetAdminLocks(response: Response): Promise<LockResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <LockResponse[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<LockResponse[]>(<any>null);
  }

  /**
   * Get all tenants the system
   * @param page (optional) pagination page
   * @param pageSize (optional) pagination pageSize
   * @param searchString (optional) pagination searchString
   * @return Success
   */
  getTenants(
    page: number | undefined,
    pageSize: number | undefined,
    searchString: string | undefined,
  ): Promise<TenantResponse[]> {
    let url_ = this.baseUrl + "/api/Admin/tenants?";
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (searchString === null)
      throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined)
      url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetTenants(_response);
      });
  }

  protected processGetTenants(response: Response): Promise<TenantResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <TenantResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<TenantResponse[]>(<any>null);
  }

  /**
   * Get all mapped sites in the system
   * @param page (optional) pagination page
   * @param pageSize (optional) pagination pageSize
   * @param searchString (optional) pagination searchString
   * @return Success
   */
  getAdminSites(
    page: number | undefined,
    pageSize: number | undefined,
    searchString: string | undefined,
  ): Promise<SiteResponse[]> {
    let url_ = this.baseUrl + "/api/Admin/sites?";
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (searchString === null)
      throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined)
      url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAdminSites(_response);
      });
  }

  protected processGetAdminSites(response: Response): Promise<SiteResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <SiteResponse[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<SiteResponse[]>(<any>null);
  }

  /**
   * Get all accounts in the system
   * @param page (optional) pagination page
   * @param pageSize (optional) pagination pageSize
   * @param searchString (optional) pagination searchString
   * @return Success
   */
  getAdminAccounts(
    page: number | undefined,
    pageSize: number | undefined,
    searchString: string | undefined,
  ): Promise<AccountResponse[]> {
    let url_ = this.baseUrl + "/api/Admin/accounts?";
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (searchString === null)
      throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined)
      url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAdminAccounts(_response);
      });
  }

  protected processGetAdminAccounts(
    response: Response,
  ): Promise<AccountResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <AccountResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<AccountResponse[]>(<any>null);
  }

  /**
   * Get all shared account credentials in the system
   * @param page (optional) pagination page
   * @param pageSize (optional) pagination pageSize
   * @param searchString (optional) pagination searchString
   * @return Success
   */
  getAllSharedAccountCredentials(
    page: number | undefined,
    pageSize: number | undefined,
    searchString: string | undefined,
  ): Promise<SharedAccountCredentialsResponse[]> {
    let url_ = this.baseUrl + "/api/Admin/sharedCreds?";
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (searchString === null)
      throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined)
      url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAllSharedAccountCredentials(_response);
      });
  }

  protected processGetAllSharedAccountCredentials(
    response: Response,
  ): Promise<SharedAccountCredentialsResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <SharedAccountCredentialsResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<SharedAccountCredentialsResponse[]>(<any>null);
  }

  /**
   * Get all access control groups in the system
   * @param page (optional) pagination page
   * @param pageSize (optional) pagination pageSize
   * @param searchString (optional) pagination searchString
   * @return Success
   */
  getAllAccessControlGroups(
    page: number | undefined,
    pageSize: number | undefined,
    searchString: string | undefined,
  ): Promise<AccessControlGroupResponse[]> {
    let url_ = this.baseUrl + "/api/Admin/accessControlGroups?";
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (searchString === null)
      throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined)
      url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAllAccessControlGroups(_response);
      });
  }

  protected processGetAllAccessControlGroups(
    response: Response,
  ): Promise<AccessControlGroupResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <AccessControlGroupResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<AccessControlGroupResponse[]>(<any>null);
  }

  /**
   * Get all screens in the system
   * @param page (optional) pagination page
   * @param pageSize (optional) pagination pageSize
   * @param searchString (optional) pagination searchString
   * @return Success
   */
  getAdminScreens(
    page: number | undefined,
    pageSize: number | undefined,
    searchString: string | undefined,
  ): Promise<ScreenResponse[]> {
    let url_ = this.baseUrl + "/api/Admin/screens?";
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (searchString === null)
      throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined)
      url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAdminScreens(_response);
      });
  }

  protected processGetAdminScreens(
    response: Response,
  ): Promise<ScreenResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <ScreenResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<ScreenResponse[]>(<any>null);
  }

  /**
   * Get all connect users in the system
   * @param page (optional) pagination page
   * @param pageSize (optional) pagination pageSize
   * @param searchString (optional) pagination searchString
   * @return Success
   */
  getAdminUsers(
    page: number | undefined,
    pageSize: number | undefined,
    searchString: string | undefined,
  ): Promise<ConnectUserResponse[]> {
    let url_ = this.baseUrl + "/api/Admin/users?";
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (searchString === null)
      throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined)
      url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAdminUsers(_response);
      });
  }

  protected processGetAdminUsers(
    response: Response,
  ): Promise<ConnectUserResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <ConnectUserResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<ConnectUserResponse[]>(<any>null);
  }

  /**
   * Get all mapped site users in the system
   * @param page (optional) pagination page
   * @param pageSize (optional) pagination pageSize
   * @param searchString (optional) pagination searchString
   * @return Success
   */
  getAdminSiteUsers(
    page: number | undefined,
    pageSize: number | undefined,
    searchString: string | undefined,
  ): Promise<SiteUserResponse[]> {
    let url_ = this.baseUrl + "/api/Admin/siteUsers?";
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (searchString === null)
      throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined)
      url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAdminSiteUsers(_response);
      });
  }

  protected processGetAdminSiteUsers(
    response: Response,
  ): Promise<SiteUserResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <SiteUserResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<SiteUserResponse[]>(<any>null);
  }

  /**
   * Get all key requests in the system (aka "Access Log")
   * @param page (optional) pagination page
   * @param pageSize (optional) pagination pageSize
   * @return Success
   */
  getAdminKeyRequests(
    page: number | undefined,
    pageSize: number | undefined,
  ): Promise<KeyRequestResponse[]> {
    let url_ = this.baseUrl + "/api/Admin/keyRequests?";
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAdminKeyRequests(_response);
      });
  }

  protected processGetAdminKeyRequests(
    response: Response,
  ): Promise<KeyRequestResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <KeyRequestResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<KeyRequestResponse[]>(<any>null);
  }

  /**
   * Ping assa proxy site
   * @return Success
   */
  proxyPing(siteId: string): Promise<void> {
    let url_ = this.baseUrl + "/api/AssaProxyPing/pingassa/{siteId}";
    if (siteId === undefined || siteId === null)
      throw new Error("The parameter 'siteId' must be defined.");
    url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processProxyPing(_response);
      });
  }

  protected processProxyPing(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Get users for tenant
   * @param page (optional) pagination page
   * @param pageSize (optional) pagination pageSize
   * @param searchString (optional) pagination searchString
   * @param tenantExternalId (optional) tenant unique name, e.g. Livly
   * @return Success
   */
  getConnectUsers(
    page: number | undefined,
    pageSize: number | undefined,
    searchString: string | undefined,
    tenantExternalId: string | undefined,
  ): Promise<ConnectUserResponse[]> {
    let url_ = this.baseUrl + "/api/ConnectUsers?";
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (searchString === null)
      throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined)
      url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
    if (tenantExternalId === null)
      throw new Error("The parameter 'tenantExternalId' cannot be null.");
    else if (tenantExternalId !== undefined)
      url_ +=
        "tenantExternalId=" + encodeURIComponent("" + tenantExternalId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetConnectUsers(_response);
      });
  }

  protected processGetConnectUsers(
    response: Response,
  ): Promise<ConnectUserResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <ConnectUserResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<ConnectUserResponse[]>(<any>null);
  }

  /**
   * Register user in Auth0 and Connect
   * @param body (optional) user information
   * @return Success
   */
  postAuth0User(
    body: RegisterConnectUserRequest | undefined,
  ): Promise<ConnectUserResponse> {
    let url_ = this.baseUrl + "/api/ConnectUsers";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPostAuth0User(_response);
      });
  }

  protected processPostAuth0User(
    response: Response,
  ): Promise<ConnectUserResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <ConnectUserResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<ConnectUserResponse>(<any>null);
  }

  /**
   * Get user
   * @param id user id
   * @return Success
   */
  getUser(id: string): Promise<ConnectUserResponse> {
    let url_ = this.baseUrl + "/api/ConnectUsers/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetUser(_response);
      });
  }

  protected processGetUser(response: Response): Promise<ConnectUserResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <ConnectUserResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<ConnectUserResponse>(<any>null);
  }

  /**
   * Delete user
   * @param id id of connectUser
   * @return Success
   */
  deleteConnectUser(id: string): Promise<void> {
    let url_ = this.baseUrl + "/api/ConnectUsers/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "DELETE",
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteConnectUser(_response);
      });
  }

  protected processDeleteConnectUser(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Get logged-in user
   * @return Success
   */
  getMe(): Promise<ConnectUserResponse> {
    let url_ = this.baseUrl + "/api/ConnectUsers/me";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetMe(_response);
      });
  }

  protected processGetMe(response: Response): Promise<ConnectUserResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <ConnectUserResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<ConnectUserResponse>(<any>null);
  }

  /**
   * Register backend/system user in Connect
   * @param body (optional) user information
   * @return Success
   */
  postBackendUser(
    body: RegisterBackendUserRequest | undefined,
  ): Promise<ConnectUserResponse> {
    let url_ = this.baseUrl + "/api/ConnectUsers/backend";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPostBackendUser(_response);
      });
  }

  protected processPostBackendUser(
    response: Response,
  ): Promise<ConnectUserResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <ConnectUserResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<ConnectUserResponse>(<any>null);
  }

  /**
   * Switch to another tenant in Auth0
   * @param id user id
   * @param tenantId tenant id
   * @return Success
   */
  switchToTenant(id: string, tenantId: string): Promise<ConnectUserResponse> {
    let url_ = this.baseUrl + "/api/ConnectUsers/{id}/switch/{tenantId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (tenantId === undefined || tenantId === null)
      throw new Error("The parameter 'tenantId' must be defined.");
    url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSwitchToTenant(_response);
      });
  }

  protected processSwitchToTenant(
    response: Response,
  ): Promise<ConnectUserResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <ConnectUserResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<ConnectUserResponse>(<any>null);
  }

  /**
   * Associate user and tenant
   * @param id user id
   * @param tenantId tenant id
   * @param role (optional) role
   * @return Success
   */
  inviteToTenant(
    id: string,
    tenantId: string,
    role: string | undefined,
  ): Promise<ConnectUserResponse> {
    let url_ = this.baseUrl + "/api/ConnectUsers/{id}/{tenantId}?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (tenantId === undefined || tenantId === null)
      throw new Error("The parameter 'tenantId' must be defined.");
    url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
    if (role === null) throw new Error("The parameter 'role' cannot be null.");
    else if (role !== undefined)
      url_ += "role=" + encodeURIComponent("" + role) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processInviteToTenant(_response);
      });
  }

  protected processInviteToTenant(
    response: Response,
  ): Promise<ConnectUserResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <ConnectUserResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<ConnectUserResponse>(<any>null);
  }

  /**
   * Associate backend/system user and tenant
   * @param body (optional) details
   * @return Success
   */
  inviteBackendToTenant(
    body: InviteBackendToTenant | undefined,
  ): Promise<ConnectUserResponse> {
    let url_ = this.baseUrl + "/api/ConnectUsers/backend/inviteToTenant";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processInviteBackendToTenant(_response);
      });
  }

  protected processInviteBackendToTenant(
    response: Response,
  ): Promise<ConnectUserResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <ConnectUserResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<ConnectUserResponse>(<any>null);
  }

  /**
   * Get invites for an authorized guest
   * @param page (optional) pagination page
   * @param pageSize (optional) pagination pageSize
   * @return Success
   */
  getMyInvites(
    page: number | undefined,
    pageSize: number | undefined,
  ): Promise<GuestInviteResponse[]> {
    let url_ = this.baseUrl + "/api/Guest/my/invites?";
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetMyInvites(_response);
      });
  }

  protected processGetMyInvites(
    response: Response,
  ): Promise<GuestInviteResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <GuestInviteResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<GuestInviteResponse[]>(<any>null);
  }

  /**
   * Get all invites for the tenant or all for superadmin (dashboard)
   * @param page (optional) pagination page
   * @param pageSize (optional) pagination pageSize
   * @param searchString (optional) pagination searchString
   * @param tenantExternalId (optional) tenant unique name, e.g. Livly
   * @return Success
   */
  getAllInvites(
    page: number | undefined,
    pageSize: number | undefined,
    searchString: string | undefined,
    tenantExternalId: string | undefined,
  ): Promise<GuestInviteResponse[]> {
    let url_ = this.baseUrl + "/api/Guest/invites?";
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (searchString === null)
      throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined)
      url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
    if (tenantExternalId === null)
      throw new Error("The parameter 'tenantExternalId' cannot be null.");
    else if (tenantExternalId !== undefined)
      url_ +=
        "tenantExternalId=" + encodeURIComponent("" + tenantExternalId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAllInvites(_response);
      });
  }

  protected processGetAllInvites(
    response: Response,
  ): Promise<GuestInviteResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <GuestInviteResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<GuestInviteResponse[]>(<any>null);
  }

  /**
   * Get invite detail for guest
   * @param id id of original invite
   * @return Success
   */
  getInvite(id: string): Promise<GuestInviteResponse> {
    let url_ = this.baseUrl + "/api/Guest/invites/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetInvite(_response);
      });
  }

  protected processGetInvite(response: Response): Promise<GuestInviteResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <GuestInviteResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<GuestInviteResponse>(<any>null);
  }

  /**
   * Get invite detail for guest from lockId
   * @param body (optional) invite information
   * @return Success
   */
  getInviteByLock(
    body: GuestInviteByLock | undefined,
  ): Promise<GuestInviteResponse> {
    let url_ = this.baseUrl + "/api/Guest/invites/byLock";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetInviteByLock(_response);
      });
  }

  protected processGetInviteByLock(
    response: Response,
  ): Promise<GuestInviteResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <GuestInviteResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<GuestInviteResponse>(<any>null);
  }

  /**
   * Create an invitation
   * @param body (optional) invite information
   * @return Success
   */
  postInvite(body: KeyChainRequest | undefined): Promise<GuestTokenResponse> {
    let url_ = this.baseUrl + "/api/Guest/invites/create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPostInvite(_response);
      });
  }

  protected processPostInvite(response: Response): Promise<GuestTokenResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <GuestTokenResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<GuestTokenResponse>(<any>null);
  }

  /**
   * Open door from an invitation
   * @param body (optional) invite information
   * @return Success
   */
  openDoorFromInvite(
    body: GuestKeyRequest | undefined,
  ): Promise<GuestKeyRequestResponse> {
    let url_ = this.baseUrl + "/api/Guest/keyRequests";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processOpenDoorFromInvite(_response);
      });
  }

  protected processOpenDoorFromInvite(
    response: Response,
  ): Promise<GuestKeyRequestResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <GuestKeyRequestResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<GuestKeyRequestResponse>(<any>null);
  }

  /**
   * Delete an invite
   * @param id id of invite to delete
   * @return Success
   */
  deleteInvite(id: string): Promise<void> {
    let url_ = this.baseUrl + "/api/Guest/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "DELETE",
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteInvite(_response);
      });
  }

  protected processDeleteInvite(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Refresh Assa mobile keys - to deal with keys expiring
   * @param body (optional) request information
   * @return Success
   */
  refreshAssaKeys(
    body: RefreshAssaKeysRequest | undefined,
  ): Promise<GuestKeyRequestResponse> {
    let url_ = this.baseUrl + "/api/Guest/refreshAssaKeys";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processRefreshAssaKeys(_response);
      });
  }

  protected processRefreshAssaKeys(
    response: Response,
  ): Promise<GuestKeyRequestResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <GuestKeyRequestResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<GuestKeyRequestResponse>(<any>null);
  }

  /**
   * Replace Assa mobile keys on invite for site - revoke or add credentials
   * @param body (optional) request information
   * @return Success
   */
  replaceAssaKeys(
    body: ReplaceAssaKeysRequest | undefined,
  ): Promise<GuestKeyRequestResponse> {
    let url_ = this.baseUrl + "/api/Guest/replaceAssaKeys";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processReplaceAssaKeys(_response);
      });
  }

  protected processReplaceAssaKeys(
    response: Response,
  ): Promise<GuestKeyRequestResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <GuestKeyRequestResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<GuestKeyRequestResponse>(<any>null);
  }

  /**
   * Delete Assa endpoints on invite (for all sites or provided siteId)
   * @param body (optional) request information
   * @return Success
   */
  deleteAssaEndpointsFromInvite(
    body: RevokeAssaEndpoints | undefined,
  ): Promise<GuestKeyRequestResponse> {
    let url_ = this.baseUrl + "/api/Guest/deleteAssaEndpoints";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteAssaEndpointsFromInvite(_response);
      });
  }

  protected processDeleteAssaEndpointsFromInvite(
    response: Response,
  ): Promise<GuestKeyRequestResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <GuestKeyRequestResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<GuestKeyRequestResponse>(<any>null);
  }

  /**
   * Backend: Get invites for an authorized guest
   * @param page (optional) pagination page
   * @param pageSize (optional) pagination pageSize
   * @param body (optional) guestInfo like guestSms
   * @return Success
   */
  getGuestInvites(
    page: number | undefined,
    pageSize: number | undefined,
    body: GuestInfo | undefined,
  ): Promise<GuestInviteResponse[]> {
    let url_ = this.baseUrl + "/api/Guest/backend/invites?";
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetGuestInvites(_response);
      });
  }

  protected processGetGuestInvites(
    response: Response,
  ): Promise<GuestInviteResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <GuestInviteResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<GuestInviteResponse[]>(<any>null);
  }

  /**
   * Backend: Get latest invite for an authorized guest for any authorized property
   * @param body (optional) guestInfo like guestSms
   * @return Success
   */
  getGuestLatestInvite(
    body: BaseGuestInfo | undefined,
  ): Promise<GuestInviteResponse> {
    let url_ = this.baseUrl + "/api/Guest/backend/invites/latest";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetGuestLatestInvite(_response);
      });
  }

  protected processGetGuestLatestInvite(
    response: Response,
  ): Promise<GuestInviteResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <GuestInviteResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<GuestInviteResponse>(<any>null);
  }

  /**
   * Backend: Get latest invite for an authorized guest for any authorized property
   * @param body (optional) guestInfo like guestSms
   * @return Success
   */
  getGuestLatestKeyRing(
    body: BaseGuestInfo | undefined,
  ): Promise<GuestInviteResponse> {
    let url_ = this.baseUrl + "/api/Guest/backend/keyRings/latest";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetGuestLatestKeyRing(_response);
      });
  }

  protected processGetGuestLatestKeyRing(
    response: Response,
  ): Promise<GuestInviteResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <GuestInviteResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<GuestInviteResponse>(<any>null);
  }

  /**
   * Onboard a user by creating an invite
   * @param body (optional) request info
   * @return Success
   */
  createOnboardInvite(
    body: OnboardCreateInviteRequest | undefined,
  ): Promise<GuestInviteResponse> {
    let url_ = this.baseUrl + "/api/Guest/backend/invites/onboard";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processCreateOnboardInvite(_response);
      });
  }

  protected processCreateOnboardInvite(
    response: Response,
  ): Promise<GuestInviteResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <GuestInviteResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<GuestInviteResponse>(<any>null);
  }

  /**
   * Mark user as needing to re-onboard - revoke existing credentials
   * @param body (optional) request info
   * @return Success
   */
  reOnboard(
    body: OnboardCreateInviteRequest | undefined,
  ): Promise<OnboardCreateInviteRequest> {
    let url_ = this.baseUrl + "/api/Guest/backend/invites/reonboard";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processReOnboard(_response);
      });
  }

  protected processReOnboard(
    response: Response,
  ): Promise<OnboardCreateInviteRequest> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <OnboardCreateInviteRequest>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<OnboardCreateInviteRequest>(<any>null);
  }

  /**
   * Onboard or update a resident guest's units/access control groups (V2, idempotent)
   * @param body request info
   * @return Success
   */
  onboardResident(body: OnboardCreateInviteRequest): Promise<void> {
    let url_ = this.baseUrl + "/api/onboarding/resident";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processOnboardResident(_response);
      });
  }

  protected processOnboardResident(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Preview the access control groups a resident guest would be granted, without persisting anything
   * @param request request info
   * @return Success
   */
  previewResident(
    request: OnboardCreateInviteRequest,
  ): Promise<OnboardingPreviewResponse> {
    let url_ = this.baseUrl + "/api/onboarding/resident/preview";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPreviewResident(_response);
      });
  }

  protected processPreviewResident(
    response: Response,
  ): Promise<OnboardingPreviewResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <OnboardingPreviewResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<OnboardingPreviewResponse>(<any>null);
  }

  /**
   * Onboard or update a staff guest's property access control groups (V2, idempotent)
   * @param body request info
   * @return Success
   */
  onboardStaff(body: StaffOnboardingRequest): Promise<void> {
    let url_ = this.baseUrl + "/api/onboarding/staff";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processOnboardStaff(_response);
      });
  }

  protected processOnboardStaff(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Preview the access control groups a staff guest would be granted, without persisting anything
   * @param request request info
   * @return Success
   */
  previewStaff(
    request: StaffOnboardingRequest,
  ): Promise<OnboardingPreviewResponse> {
    let url_ = this.baseUrl + "/api/onboarding/staff/preview";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPreviewStaff(_response);
      });
  }

  protected processPreviewStaff(
    response: Response,
  ): Promise<OnboardingPreviewResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <OnboardingPreviewResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<OnboardingPreviewResponse>(<any>null);
  }

  /**
   * Backend: Get keyrings for an authorized guest
   * @param page (optional) pagination page
   * @param pageSize (optional) pagination pageSize
   * @param body (optional) guestInfo like guestSms
   * @return Success
   */
  getGuestKeyRings(
    page: number | undefined,
    pageSize: number | undefined,
    body: GuestInfo | undefined,
  ): Promise<GuestInviteResponse[]> {
    let url_ = this.baseUrl + "/api/Guest/backend/keyrings?";
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetGuestKeyRings(_response);
      });
  }

  protected processGetGuestKeyRings(
    response: Response,
  ): Promise<GuestInviteResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <GuestInviteResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<GuestInviteResponse[]>(<any>null);
  }

  /**
   * Get invites FROM an authorized guest
   * @param page (optional) pagination page
   * @param pageSize (optional) pagination pageSize
   * @param searchString (optional) pagination searchString
   * @return Success
   */
  getFromMeInvites(
    page: number | undefined,
    pageSize: number | undefined,
    searchString: string | undefined,
  ): Promise<GuestInviteResponse[]> {
    let url_ = this.baseUrl + "/api/Guest/from/me/invites?";
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (searchString === null)
      throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined)
      url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetFromMeInvites(_response);
      });
  }

  protected processGetFromMeInvites(
    response: Response,
  ): Promise<GuestInviteResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <GuestInviteResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<GuestInviteResponse[]>(<any>null);
  }

  /**
   * Backend: Get invites FROM or TO an authorized guest
   * @param page (optional) pagination page
   * @param pageSize (optional) pagination pageSize
   * @param searchString (optional) pagination searchString
   * @param body (optional) guestInfo like guestSms
   * @return Success
   */
  getFromGuestInvites(
    page: number | undefined,
    pageSize: number | undefined,
    searchString: string | undefined,
    body: GuestInfo | undefined,
  ): Promise<GuestInviteResponse[]> {
    let url_ = this.baseUrl + "/api/Guest/backend/from/invites?";
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (searchString === null)
      throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined)
      url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetFromGuestInvites(_response);
      });
  }

  protected processGetFromGuestInvites(
    response: Response,
  ): Promise<GuestInviteResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <GuestInviteResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<GuestInviteResponse[]>(<any>null);
  }

  /**
   * Get access log for guest and their guests
   * @param page (optional) pagination page
   * @param pageSize (optional) pagination pageSize
   * @return Success
   */
  getFromMeAccessLog(
    page: number | undefined,
    pageSize: number | undefined,
  ): Promise<KeyRequestResponse[]> {
    let url_ = this.baseUrl + "/api/Guest/from/me/accesslog?";
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetFromMeAccessLog(_response);
      });
  }

  protected processGetFromMeAccessLog(
    response: Response,
  ): Promise<KeyRequestResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <KeyRequestResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<KeyRequestResponse[]>(<any>null);
  }

  /**
   * Backend: Get access log for an authorized guest and their guests
   * @param page (optional) pagination page
   * @param pageSize (optional) pagination pageSize
   * @param body (optional) guestInfo like guestSms
   * @return Success
   */
  getGuestAccessLog(
    page: number | undefined,
    pageSize: number | undefined,
    body: GuestInfo | undefined,
  ): Promise<KeyRequestResponse[]> {
    let url_ = this.baseUrl + "/api/Guest/backend/from/accesslog?";
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetGuestAccessLog(_response);
      });
  }

  protected processGetGuestAccessLog(
    response: Response,
  ): Promise<KeyRequestResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <KeyRequestResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<KeyRequestResponse[]>(<any>null);
  }

  /**
   * Invite from an invitation
   * @param body (optional) invite information
   * @return Success
   */
  inviteFromInvite(
    body: InviteFromKeyChainRequest | undefined,
  ): Promise<GuestTokenResponse> {
    let url_ = this.baseUrl + "/api/Guest/inviteFromKeyRing";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processInviteFromInvite(_response);
      });
  }

  protected processInviteFromInvite(
    response: Response,
  ): Promise<GuestTokenResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <GuestTokenResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<GuestTokenResponse>(<any>null);
  }

  /**
   * Get key requests for logged-in tenant
   * @param page (optional) pagination page
   * @param pageSize (optional) pagination pageSize
   * @param tenantExternalId (optional) tenant unique name, e.g. Livly
   * @return Success
   */
  getKeyRequests(
    page: number | undefined,
    pageSize: number | undefined,
    tenantExternalId: string | undefined,
  ): Promise<KeyRequestResponse[]> {
    let url_ = this.baseUrl + "/api/KeyRequests?";
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (tenantExternalId === null)
      throw new Error("The parameter 'tenantExternalId' cannot be null.");
    else if (tenantExternalId !== undefined)
      url_ +=
        "tenantExternalId=" + encodeURIComponent("" + tenantExternalId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetKeyRequests(_response);
      });
  }

  protected processGetKeyRequests(
    response: Response,
  ): Promise<KeyRequestResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <KeyRequestResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<KeyRequestResponse[]>(<any>null);
  }

  /**
   * Main endpoint: create an open door/mobileKey request
   * @param body (optional) invite information
   * @return Success
   */
  postKeyRequest(
    body: SimpleKeyRequest | undefined,
  ): Promise<GuestKeyRequestResponse> {
    let url_ = this.baseUrl + "/api/KeyRequests";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPostKeyRequest(_response);
      });
  }

  protected processPostKeyRequest(
    response: Response,
  ): Promise<GuestKeyRequestResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <GuestKeyRequestResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<GuestKeyRequestResponse>(<any>null);
  }

  /**
   * Called only by Assa firebase proxy after it finishes processing a keyRequest
   * @param body (optional) result of processing the keyRequest (success or failure)
   * @return Success
   */
  postKeyRequestIssued(
    body: KeyIssuedRequest | undefined,
  ): Promise<KeyRequestResponse> {
    let url_ = this.baseUrl + "/api/lock/keyRequest/issued";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPostKeyRequestIssued(_response);
      });
  }

  protected processPostKeyRequestIssued(
    response: Response,
  ): Promise<KeyRequestResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <KeyRequestResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<KeyRequestResponse>(<any>null);
  }

  /**
   * Delete a key request
   * @param id id of key request to delete
   * @return Success
   */
  deleteKeyRequest(id: string): Promise<void> {
    let url_ = this.baseUrl + "/api/KeyRequests/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "DELETE",
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteKeyRequest(_response);
      });
  }

  protected processDeleteKeyRequest(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Get a pin
   * @param body (optional) get pin request details
   * @return Success
   */
  getPin(body: SimpleKeyRequest | undefined): Promise<GuestKeyRequestResponse> {
    let url_ = this.baseUrl + "/api/KeyRequests/getPin";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetPin(_response);
      });
  }

  protected processGetPin(
    response: Response,
  ): Promise<GuestKeyRequestResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <GuestKeyRequestResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<GuestKeyRequestResponse>(<any>null);
  }

  /**
   * Get locks for logged-in tenant
   * @param page (optional) pagination page
   * @param pageSize (optional) pagination pageSize
   * @param searchString (optional) pagination searchString
   * @param tenantExternalId (optional) tenant unique name, e.g. Livly
   * @return Success
   */
  getLocks(
    page: number | undefined,
    pageSize: number | undefined,
    searchString: string | undefined,
    tenantExternalId: string | undefined,
  ): Promise<LockResponse[]> {
    let url_ = this.baseUrl + "/api/Locks?";
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (searchString === null)
      throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined)
      url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
    if (tenantExternalId === null)
      throw new Error("The parameter 'tenantExternalId' cannot be null.");
    else if (tenantExternalId !== undefined)
      url_ +=
        "tenantExternalId=" + encodeURIComponent("" + tenantExternalId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetLocks(_response);
      });
  }

  protected processGetLocks(response: Response): Promise<LockResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <LockResponse[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<LockResponse[]>(<any>null);
  }

  /**
   * Map a lock
   * @param body (optional) lock info
   * @return Success
   */
  postLock(
    body: RegisterLockRequest | undefined,
  ): Promise<RegisterLockResponse> {
    let url_ = this.baseUrl + "/api/Locks";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPostLock(_response);
      });
  }

  protected processPostLock(response: Response): Promise<RegisterLockResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <RegisterLockResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<RegisterLockResponse>(<any>null);
  }

  /**
   * Map a batch of locks, to be used for onboarding sites/properties
   * @param file (optional)
   * @return Success
   */
  batchPostLocks(
    file: FileParameter | undefined,
  ): Promise<BatchRegisterLockResponse> {
    let url_ = this.baseUrl + "/api/Locks/batch";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (file === null || file === undefined)
      throw new Error("The parameter 'file' cannot be null.");
    else
      content_.append(
        "File",
        file.data,
        file.fileName ? file.fileName : "File",
      );

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processBatchPostLocks(_response);
      });
  }

  protected processBatchPostLocks(
    response: Response,
  ): Promise<BatchRegisterLockResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <BatchRegisterLockResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<BatchRegisterLockResponse>(<any>null);
  }

  /**
   * Delete a lock
   * @param id id of lock
   * @return Success
   */
  deleteLock(id: string): Promise<void> {
    let url_ = this.baseUrl + "/api/Locks/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "DELETE",
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteLock(_response);
      });
  }

  protected processDeleteLock(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Updates a lock
   * @param id id of lock
   * @param body (optional)
   * @return Success
   */
  putLock(
    id: string,
    body: UpdateLockRequest | undefined,
  ): Promise<LockResponse> {
    let url_ = this.baseUrl + "/api/Locks/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPutLock(_response);
      });
  }

  protected processPutLock(response: Response): Promise<LockResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <LockResponse>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<LockResponse>(<any>null);
  }

  /**
   * Gets a specific lock by ID
   * @param tenantExternalId (optional)
   * @return Success
   */
  getLock(
    id: string,
    tenantExternalId: string | undefined,
  ): Promise<LockResponse> {
    let url_ = this.baseUrl + "/api/Locks/{id}?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (tenantExternalId === null)
      throw new Error("The parameter 'tenantExternalId' cannot be null.");
    else if (tenantExternalId !== undefined)
      url_ +=
        "tenantExternalId=" + encodeURIComponent("" + tenantExternalId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetLock(_response);
      });
  }

  protected processGetLock(response: Response): Promise<LockResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <LockResponse>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<LockResponse>(<any>null);
  }

  /**
   * @return Success
   */
  getLockDatabase(systemLockId: string): Promise<void> {
    let url_ = this.baseUrl + "/api/Locks/{systemLockId}/database";
    if (systemLockId === undefined || systemLockId === null)
      throw new Error("The parameter 'systemLockId' must be defined.");
    url_ = url_.replace(
      "{systemLockId}",
      encodeURIComponent("" + systemLockId),
    );
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetLockDatabase(_response);
      });
  }

  protected processGetLockDatabase(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  getLockSiteExternalId(
    systemLockId: string,
  ): Promise<LockSiteExternalIdResponse> {
    let url_ = this.baseUrl + "/api/Locks/{systemLockId}/siteExternalId";
    if (systemLockId === undefined || systemLockId === null)
      throw new Error("The parameter 'systemLockId' must be defined.");
    url_ = url_.replace(
      "{systemLockId}",
      encodeURIComponent("" + systemLockId),
    );
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetLockSiteExternalId(_response);
      });
  }

  protected processGetLockSiteExternalId(
    response: Response,
  ): Promise<LockSiteExternalIdResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <LockSiteExternalIdResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<LockSiteExternalIdResponse>(<any>null);
  }

  /**
   * @return Success
   */
  getLockTemporaryKeyForDevice(
    systemLockId: string,
    deviceUniqueId: string,
  ): Promise<DeviceTemporaryKeyResponse> {
    let url_ =
      this.baseUrl + "/api/Locks/{systemLockId}/temporaryKey/{deviceUniqueId}";
    if (systemLockId === undefined || systemLockId === null)
      throw new Error("The parameter 'systemLockId' must be defined.");
    url_ = url_.replace(
      "{systemLockId}",
      encodeURIComponent("" + systemLockId),
    );
    if (deviceUniqueId === undefined || deviceUniqueId === null)
      throw new Error("The parameter 'deviceUniqueId' must be defined.");
    url_ = url_.replace(
      "{deviceUniqueId}",
      encodeURIComponent("" + deviceUniqueId),
    );
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetLockTemporaryKeyForDevice(_response);
      });
  }

  protected processGetLockTemporaryKeyForDevice(
    response: Response,
  ): Promise<DeviceTemporaryKeyResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <DeviceTemporaryKeyResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<DeviceTemporaryKeyResponse>(<any>null);
  }

  /**
   * @param flags (optional)
   * @return Success
   */
  syncLock(id: string, flags: number | undefined): Promise<any> {
    let url_ = this.baseUrl + "/api/Locks/{id}/sync?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (flags === null)
      throw new Error("The parameter 'flags' cannot be null.");
    else if (flags !== undefined)
      url_ += "flags=" + encodeURIComponent("" + flags) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSyncLock(_response);
      });
  }

  protected processSyncLock(response: Response): Promise<any> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <any>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<any>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  postLockEvents(
    id: string,
    body: LockEventModel[] | undefined,
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/Locks/{id}/events";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPostLockEvents(_response);
      });
  }

  protected processPostLockEvents(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @param skip (optional)
   * @param take (optional)
   * @return Success
   */
  getLockEvents(
    id: string,
    skip: number | undefined,
    take: number | undefined,
  ): Promise<LockEventModel[]> {
    let url_ = this.baseUrl + "/api/Locks/{id}/events?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (skip === null) throw new Error("The parameter 'skip' cannot be null.");
    else if (skip !== undefined)
      url_ += "skip=" + encodeURIComponent("" + skip) + "&";
    if (take === null) throw new Error("The parameter 'take' cannot be null.");
    else if (take !== undefined)
      url_ += "take=" + encodeURIComponent("" + take) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetLockEvents(_response);
      });
  }

  protected processGetLockEvents(
    response: Response,
  ): Promise<LockEventModel[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <LockEventModel[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<LockEventModel[]>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  postLockEventsBySystemLockId(
    systemLockId: string,
    body: LockEventModel[] | undefined,
  ): Promise<void> {
    let url_ = this.baseUrl + "/serialNumber/{systemLockId}/events";
    if (systemLockId === undefined || systemLockId === null)
      throw new Error("The parameter 'systemLockId' must be defined.");
    url_ = url_.replace(
      "{systemLockId}",
      encodeURIComponent("" + systemLockId),
    );
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPostLockEventsBySystemLockId(_response);
      });
  }

  protected processPostLockEventsBySystemLockId(
    response: Response,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  getLockFirmware(id: string): Promise<LockAvailableFirmwareResponse[]> {
    let url_ = this.baseUrl + "/api/Locks/{id}/firmware";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetLockFirmware(_response);
      });
  }

  protected processGetLockFirmware(
    response: Response,
  ): Promise<LockAvailableFirmwareResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <LockAvailableFirmwareResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<LockAvailableFirmwareResponse[]>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  setLockFirmware(
    id: string,
    body: LockFirmwareUpdateRequest | undefined,
  ): Promise<any> {
    let url_ = this.baseUrl + "/api/Locks/{id}/firmware";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSetLockFirmware(_response);
      });
  }

  protected processSetLockFirmware(response: Response): Promise<any> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <any>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<any>(<any>null);
  }

  /**
   * @return Success
   */
  getGatewayInfo(id: string): Promise<GatewayInfoResponse> {
    let url_ = this.baseUrl + "/api/Locks/{id}/gateway";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetGatewayInfo(_response);
      });
  }

  protected processGetGatewayInfo(
    response: Response,
  ): Promise<GatewayInfoResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <GatewayInfoResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<GatewayInfoResponse>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  startGatewayFirmwareUpgrade(
    id: string,
    model: string,
    body: LockFirmwareUpdateRequest | undefined,
  ): Promise<any> {
    let url_ = this.baseUrl + "/api/Locks/{id}/gateway/{model}/firmware";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (model === undefined || model === null)
      throw new Error("The parameter 'model' must be defined.");
    url_ = url_.replace("{model}", encodeURIComponent("" + model));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processStartGatewayFirmwareUpgrade(_response);
      });
  }

  protected processStartGatewayFirmwareUpgrade(
    response: Response,
  ): Promise<any> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <any>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<any>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  putLockConfigBySystemLockId(
    systemLockId: string,
    body: LockConfigRequestModel | undefined,
  ): Promise<void> {
    let url_ = this.baseUrl + "/serialNumber/{systemLockId}/config";
    if (systemLockId === undefined || systemLockId === null)
      throw new Error("The parameter 'systemLockId' must be defined.");
    url_ = url_.replace(
      "{systemLockId}",
      encodeURIComponent("" + systemLockId),
    );
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json-patch+json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPutLockConfigBySystemLockId(_response);
      });
  }

  protected processPutLockConfigBySystemLockId(
    response: Response,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Adds a lock automation
   * @param body (optional)
   * @return Success
   */
  addLockAutomation(
    lockId: string,
    body: LockAutomationRequest | undefined,
  ): Promise<LockAutomationResponse> {
    let url_ = this.baseUrl + "/api/Locks/{lockId}/automations";
    if (lockId === undefined || lockId === null)
      throw new Error("The parameter 'lockId' must be defined.");
    url_ = url_.replace("{lockId}", encodeURIComponent("" + lockId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAddLockAutomation(_response);
      });
  }

  protected processAddLockAutomation(
    response: Response,
  ): Promise<LockAutomationResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        result201 =
          _responseText === ""
            ? null
            : <LockAutomationResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result201;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<LockAutomationResponse>(<any>null);
  }

  /**
   * Gets all lock automations
   * @return Success
   */
  getLockAutomations(lockId: string): Promise<LockAutomationResponse[]> {
    let url_ = this.baseUrl + "/api/Locks/{lockId}/automations";
    if (lockId === undefined || lockId === null)
      throw new Error("The parameter 'lockId' must be defined.");
    url_ = url_.replace("{lockId}", encodeURIComponent("" + lockId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetLockAutomations(_response);
      });
  }

  protected processGetLockAutomations(
    response: Response,
  ): Promise<LockAutomationResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <LockAutomationResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<LockAutomationResponse[]>(<any>null);
  }

  /**
   * Updates a lock automation
   * @param body (optional)
   * @return Success
   */
  updateLockAutomation(
    lockId: string,
    id: string,
    body: LockAutomationRequest | undefined,
  ): Promise<LockAutomationResponse> {
    let url_ = this.baseUrl + "/api/Locks/{lockId}/automations/{id}";
    if (lockId === undefined || lockId === null)
      throw new Error("The parameter 'lockId' must be defined.");
    url_ = url_.replace("{lockId}", encodeURIComponent("" + lockId));
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateLockAutomation(_response);
      });
  }

  protected processUpdateLockAutomation(
    response: Response,
  ): Promise<LockAutomationResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <LockAutomationResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<LockAutomationResponse>(<any>null);
  }

  /**
   * Delete a scheduled automation
   * @return Success
   */
  deleteLockAutomation(lockId: string, id: string): Promise<any> {
    let url_ = this.baseUrl + "/api/Locks/{lockId}/automations/{id}";
    if (lockId === undefined || lockId === null)
      throw new Error("The parameter 'lockId' must be defined.");
    url_ = url_.replace("{lockId}", encodeURIComponent("" + lockId));
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "DELETE",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteLockAutomation(_response);
      });
  }

  protected processDeleteLockAutomation(response: Response): Promise<any> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <any>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<any>(<any>null);
  }

  /**
   * Get access control groups assigned to a lock
   * @return Success
   */
  getLockAccessControlGroups(
    id: string,
    page: number | undefined,
    pageSize: number | undefined,
    searchString: string | undefined,
  ): Promise<AccessControlGroupResponse[]> {
    let url_ = this.baseUrl + "/api/Locks/{id}/accessControlGroups?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (searchString === null)
      throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined)
      url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetLockAccessControlGroups(_response);
      });
  }

  protected processGetLockAccessControlGroups(
    response: Response,
  ): Promise<AccessControlGroupResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <AccessControlGroupResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<AccessControlGroupResponse[]>(<any>null);
  }

  /**
   * Get available access control groups that can be assigned to a lock
   * @return Success
   */
  getAvailableLockAccessControlGroups(
    id: string,
    page: number | undefined,
    pageSize: number | undefined,
    searchString: string | undefined,
  ): Promise<AccessControlGroupResponse[]> {
    let url_ = this.baseUrl + "/api/Locks/{id}/accessControlGroups/available?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (searchString === null)
      throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined)
      url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAvailableLockAccessControlGroups(_response);
      });
  }

  protected processGetAvailableLockAccessControlGroups(
    response: Response,
  ): Promise<AccessControlGroupResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <AccessControlGroupResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<AccessControlGroupResponse[]>(<any>null);
  }

  /**
   * Assign lock to an access control group
   * @return Success
   */
  addLockToAccessControlGroupByLock(
    id: string,
    accessControlGroupId: string,
  ): Promise<RegisterAccountResponse> {
    let url_ = this.baseUrl + "/api/Locks/{id}/accessControlGroups/{accessControlGroupId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (accessControlGroupId === undefined || accessControlGroupId === null)
      throw new Error("The parameter 'accessControlGroupId' must be defined.");
    url_ = url_.replace(
      "{accessControlGroupId}",
      encodeURIComponent("" + accessControlGroupId),
    );
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAddLockToAccessControlGroupByLock(_response);
      });
  }

  protected processAddLockToAccessControlGroupByLock(
    response: Response,
  ): Promise<RegisterAccountResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <RegisterAccountResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<RegisterAccountResponse>(<any>null);
  }

  /**
   * Remove lock from an access control group
   * @return Success
   */
  deleteLockFromAccessControlGroupByLock(
    id: string,
    accessControlGroupId: string,
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/Locks/{id}/accessControlGroups/{accessControlGroupId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (accessControlGroupId === undefined || accessControlGroupId === null)
      throw new Error("The parameter 'accessControlGroupId' must be defined.");
    url_ = url_.replace(
      "{accessControlGroupId}",
      encodeURIComponent("" + accessControlGroupId),
    );
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "DELETE",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteLockFromAccessControlGroupByLock(_response);
      });
  }

  protected processDeleteLockFromAccessControlGroupByLock(
    response: Response,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200 || status === 204) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Adds a holiday
   * @param body (optional)
   * @return Success
   */
  addLockHoliday(
    lockId: string,
    body: LockHolidayRequest | undefined,
  ): Promise<LockHolidayResponse> {
    let url_ = this.baseUrl + "/api/Locks/{lockId}/holidays";
    if (lockId === undefined || lockId === null)
      throw new Error("The parameter 'lockId' must be defined.");
    url_ = url_.replace("{lockId}", encodeURIComponent("" + lockId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAddLockHoliday(_response);
      });
  }

  protected processAddLockHoliday(
    response: Response,
  ): Promise<LockHolidayResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        result201 =
          _responseText === ""
            ? null
            : <LockHolidayResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result201;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<LockHolidayResponse>(<any>null);
  }

  /**
   * Get all future holidays for a lock
   * @return Success
   */
  getLockHolidays(lockId: string): Promise<LockHolidayResponse[]> {
    let url_ = this.baseUrl + "/api/Locks/{lockId}/holidays";
    if (lockId === undefined || lockId === null)
      throw new Error("The parameter 'lockId' must be defined.");
    url_ = url_.replace("{lockId}", encodeURIComponent("" + lockId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetLockHolidays(_response);
      });
  }

  protected processGetLockHolidays(
    response: Response,
  ): Promise<LockHolidayResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <LockHolidayResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<LockHolidayResponse[]>(<any>null);
  }

  /**
   * Update a holiday
   * @param body (optional)
   * @return Success
   */
  updateLockHoliday(
    lockId: string,
    id: string,
    body: LockHolidayRequest | undefined,
  ): Promise<LockHolidayResponse> {
    let url_ = this.baseUrl + "/api/Locks/{lockId}/holidays/{id}";
    if (lockId === undefined || lockId === null)
      throw new Error("The parameter 'lockId' must be defined.");
    url_ = url_.replace("{lockId}", encodeURIComponent("" + lockId));
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateLockHoliday(_response);
      });
  }

  protected processUpdateLockHoliday(
    response: Response,
  ): Promise<LockHolidayResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <LockHolidayResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<LockHolidayResponse>(<any>null);
  }

  /**
   * Delete a holiday
   * @return Success
   */
  deleteLockHoliday(lockId: string, id: string): Promise<any> {
    let url_ = this.baseUrl + "/api/Locks/{lockId}/holidays/{id}";
    if (lockId === undefined || lockId === null)
      throw new Error("The parameter 'lockId' must be defined.");
    url_ = url_.replace("{lockId}", encodeURIComponent("" + lockId));
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "DELETE",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteLockHoliday(_response);
      });
  }

  protected processDeleteLockHoliday(response: Response): Promise<any> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <any>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<any>(<any>null);
  }

  /**
   * Get invites for an authorized guest
   * @param page (optional) pagination page
   * @param pageSize (optional) pagination pageSize
   * @param body (optional) guest info including token
   * @return Success
   */
  getScreenInvites(
    page: number | undefined,
    pageSize: number | undefined,
    body: GuestInvitesRequest | undefined,
  ): Promise<ScreenInviteResponse[]> {
    let url_ = this.baseUrl + "/api/ScreenInvite/invites/get?";
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetScreenInvites(_response);
      });
  }

  protected processGetScreenInvites(
    response: Response,
  ): Promise<ScreenInviteResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <ScreenInviteResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<ScreenInviteResponse[]>(<any>null);
  }

  /**
   * Get all invites for the tenant or all for superadmin (dashboard)
   * @param page (optional) pagination page
   * @param pageSize (optional) pagination pageSize
   * @param searchString (optional) pagination searchString
   * @param tenantExternalId (optional) tenant unique name, e.g. Livly
   * @return Success
   */
  getAllScreenInvites(
    page: number | undefined,
    pageSize: number | undefined,
    searchString: string | undefined,
    tenantExternalId: string | undefined,
  ): Promise<ScreenInviteResponse[]> {
    let url_ = this.baseUrl + "/api/ScreenInvite/invites?";
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (searchString === null)
      throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined)
      url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
    if (tenantExternalId === null)
      throw new Error("The parameter 'tenantExternalId' cannot be null.");
    else if (tenantExternalId !== undefined)
      url_ +=
        "tenantExternalId=" + encodeURIComponent("" + tenantExternalId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAllScreenInvites(_response);
      });
  }

  protected processGetAllScreenInvites(
    response: Response,
  ): Promise<ScreenInviteResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <ScreenInviteResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<ScreenInviteResponse[]>(<any>null);
  }

  /**
   * Get invite detail for guest
   * @param id id of original invite
   * @return Success
   */
  getScreenInvite(id: string): Promise<ScreenInviteResponse> {
    let url_ = this.baseUrl + "/api/ScreenInvite/invites/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetScreenInvite(_response);
      });
  }

  protected processGetScreenInvite(
    response: Response,
  ): Promise<ScreenInviteResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <ScreenInviteResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<ScreenInviteResponse>(<any>null);
  }

  /**
   * Create an invitation
   * @param body (optional) invite information
   * @return Success
   */
  postScreenInvite(
    body: ScreenInviteRequest | undefined,
  ): Promise<ScreenInviteResponse> {
    let url_ = this.baseUrl + "/api/ScreenInvite/invites/create";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPostScreenInvite(_response);
      });
  }

  protected processPostScreenInvite(
    response: Response,
  ): Promise<ScreenInviteResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <ScreenInviteResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<ScreenInviteResponse>(<any>null);
  }

  /**
   * Delete an invite
   * @param id id of invite to delete
   * @return Success
   */
  deleteScreenInvite(id: string): Promise<void> {
    let url_ = this.baseUrl + "/api/ScreenInvite/invite/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "DELETE",
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteScreenInvite(_response);
      });
  }

  protected processDeleteScreenInvite(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Get screens for logged-in tenant
   * @param page (optional) pagination page
   * @param pageSize (optional) pagination pageSize
   * @param searchString (optional) pagination searchString
   * @param tenantExternalId (optional) tenant unique name, e.g. Livly
   * @param showChildren (optional) show proposal, not real, tiles
   * @return Success
   */
  getScreens(
    page: number | undefined,
    pageSize: number | undefined,
    searchString: string | undefined,
    tenantExternalId: string | undefined,
    showChildren: boolean | undefined,
  ): Promise<ScreenResponse[]> {
    let url_ = this.baseUrl + "/api/Screens?";
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (searchString === null)
      throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined)
      url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
    if (tenantExternalId === null)
      throw new Error("The parameter 'tenantExternalId' cannot be null.");
    else if (tenantExternalId !== undefined)
      url_ +=
        "tenantExternalId=" + encodeURIComponent("" + tenantExternalId) + "&";
    if (showChildren === null)
      throw new Error("The parameter 'showChildren' cannot be null.");
    else if (showChildren !== undefined)
      url_ += "showChildren=" + encodeURIComponent("" + showChildren) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetScreens(_response);
      });
  }

  protected processGetScreens(response: Response): Promise<ScreenResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <ScreenResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<ScreenResponse[]>(<any>null);
  }

  /**
   * Create a screen
   * @param body (optional) screen info
   * @return Success
   */
  postScreen(
    body: RegisterScreenRequest | undefined,
  ): Promise<RegisterScreenResponse> {
    let url_ = this.baseUrl + "/api/Screens";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPostScreen(_response);
      });
  }

  protected processPostScreen(
    response: Response,
  ): Promise<RegisterScreenResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <RegisterScreenResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<RegisterScreenResponse>(<any>null);
  }

  /**
   * Get screen detail
   * @param id id of screen
   * @return Success
   */
  getScreen(id: string): Promise<ScreenResponse> {
    let url_ = this.baseUrl + "/api/Screens/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetScreen(_response);
      });
  }

  protected processGetScreen(response: Response): Promise<ScreenResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <ScreenResponse>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<ScreenResponse>(<any>null);
  }

  /**
   * Update a screen
   * @param id id of screen
   * @param body (optional) screen info
   * @return Success
   */
  updateScreen(
    id: string,
    body: RegisterScreenRequest | undefined,
  ): Promise<RegisterScreenResponse> {
    let url_ = this.baseUrl + "/api/Screens/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateScreen(_response);
      });
  }

  protected processUpdateScreen(
    response: Response,
  ): Promise<RegisterScreenResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <RegisterScreenResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<RegisterScreenResponse>(<any>null);
  }

  /**
   * Delete a screen
   * @param id id of screen
   * @return Success
   */
  deleteScreen(id: string): Promise<void> {
    let url_ = this.baseUrl + "/api/Screens/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "DELETE",
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteScreen(_response);
      });
  }

  protected processDeleteScreen(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Get the latest HubScreen
   * @param tenantExternalId (optional) tenant unique name, e.g. Livly
   * @param propertyExternalId (optional) propertyExternalId (e.g. Livly propertyCode)
   * @return Success
   */
  getHubScreen(
    tenantExternalId: string | undefined,
    propertyExternalId: string | undefined,
  ): Promise<ScreenWrapper> {
    let url_ = this.baseUrl + "/api/Screens/hub/latest?";
    if (tenantExternalId === null)
      throw new Error("The parameter 'tenantExternalId' cannot be null.");
    else if (tenantExternalId !== undefined)
      url_ +=
        "tenantExternalId=" + encodeURIComponent("" + tenantExternalId) + "&";
    if (propertyExternalId === null)
      throw new Error("The parameter 'propertyExternalId' cannot be null.");
    else if (propertyExternalId !== undefined)
      url_ +=
        "propertyExternalId=" +
        encodeURIComponent("" + propertyExternalId) +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetHubScreen(_response);
      });
  }

  protected processGetHubScreen(response: Response): Promise<ScreenWrapper> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <ScreenWrapper>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<ScreenWrapper>(<any>null);
  }

  /**
   * Get screen children (proposals, versions, scheduled)
   * @param id id of screen to get children for
   * @param page (optional) pagination page
   * @param pageSize (optional) pagination pageSize
   * @return Success
   */
  getScreenChildren(
    id: string,
    page: number | undefined,
    pageSize: number | undefined,
  ): Promise<ScreenResponse[]> {
    let url_ = this.baseUrl + "/api/Screens/{id}/children?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetScreenChildren(_response);
      });
  }

  protected processGetScreenChildren(
    response: Response,
  ): Promise<ScreenResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <ScreenResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<ScreenResponse[]>(<any>null);
  }

  /**
   * Update a Hub screen
   * @param id id of screen
   * @param body (optional) hub screen info
   * @return Success
   */
  updateHubScreen(
    id: string,
    body: HubScreenRequest | undefined,
  ): Promise<RegisterScreenResponse> {
    let url_ = this.baseUrl + "/api/Screens/hub/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateHubScreen(_response);
      });
  }

  protected processUpdateHubScreen(
    response: Response,
  ): Promise<RegisterScreenResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <RegisterScreenResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<RegisterScreenResponse>(<any>null);
  }

  /**
   * Edit screen from invitation
   * @param body (optional) invite information
   * @return Success
   */
  updateScreenFromInvite(
    body: UpdateScreenFromInvite | undefined,
  ): Promise<RegisterScreenResponse> {
    let url_ = this.baseUrl + "/api/Screens/guest";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateScreenFromInvite(_response);
      });
  }

  protected processUpdateScreenFromInvite(
    response: Response,
  ): Promise<RegisterScreenResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <RegisterScreenResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<RegisterScreenResponse>(<any>null);
  }

  /**
   * Get shared account credentials for tenant
   * @param page (optional) pagination page
   * @param pageSize (optional) pagination pageSize
   * @param searchString (optional) pagination searchString
   * @param tenantExternalId (optional) tenant unique name, e.g. Livly
   * @return Success
   */
  getSharedAccountCredentials(
    page: number | undefined,
    pageSize: number | undefined,
    searchString: string | undefined,
    tenantExternalId: string | undefined,
  ): Promise<SharedAccountCredentialsResponse[]> {
    let url_ = this.baseUrl + "/api/SharedAccountCredentials?";
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (searchString === null)
      throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined)
      url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
    if (tenantExternalId === null)
      throw new Error("The parameter 'tenantExternalId' cannot be null.");
    else if (tenantExternalId !== undefined)
      url_ +=
        "tenantExternalId=" + encodeURIComponent("" + tenantExternalId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetSharedAccountCredentials(_response);
      });
  }

  protected processGetSharedAccountCredentials(
    response: Response,
  ): Promise<SharedAccountCredentialsResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <SharedAccountCredentialsResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<SharedAccountCredentialsResponse[]>(<any>null);
  }

  /**
   * Create shared account credentials
   * @param body (optional) account credentials info
   * @return Success
   */
  postSharedAccountCredentials(
    body: RegisterSharedAccountCredentials | undefined,
  ): Promise<RegisterAccountResponse> {
    let url_ = this.baseUrl + "/api/SharedAccountCredentials";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPostSharedAccountCredentials(_response);
      });
  }

  protected processPostSharedAccountCredentials(
    response: Response,
  ): Promise<RegisterAccountResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <RegisterAccountResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<RegisterAccountResponse>(<any>null);
  }

  /**
   * Associate shared account credentials and tenant
   * @param id shared credentials id
   * @param tenantId tenant id
   * @return Success
   */
  addSharedCredToTenant(
    id: string,
    tenantId: string,
  ): Promise<RegisterAccountResponse> {
    let url_ = this.baseUrl + "/api/SharedAccountCredentials/{id}/{tenantId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (tenantId === undefined || tenantId === null)
      throw new Error("The parameter 'tenantId' must be defined.");
    url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAddSharedCredToTenant(_response);
      });
  }

  protected processAddSharedCredToTenant(
    response: Response,
  ): Promise<RegisterAccountResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <RegisterAccountResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<RegisterAccountResponse>(<any>null);
  }

  /**
   * Delete shared account credentials
   * @param id id of shared account credentials
   * @return Success
   */
  deleteSharedAccountCredentials(id: string): Promise<void> {
    let url_ = this.baseUrl + "/api/SharedAccountCredentials/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "DELETE",
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteSharedAccountCredentials(_response);
      });
  }

  protected processDeleteSharedAccountCredentials(
    response: Response,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Get sites for logged-in tenant
   * @param page (optional) pagination page
   * @param pageSize (optional) pagination pageSize
   * @param searchString (optional) pagination searchString
   * @param tenantExternalId (optional) tenant unique name, e.g. Livly
   * @return Success
   */
  getSites(
    page: number | undefined,
    pageSize: number | undefined,
    searchString: string | undefined,
    tenantExternalId: string | undefined,
  ): Promise<SiteResponse[]> {
    let url_ = this.baseUrl + "/api/Sites?";
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (searchString === null)
      throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined)
      url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
    if (tenantExternalId === null)
      throw new Error("The parameter 'tenantExternalId' cannot be null.");
    else if (tenantExternalId !== undefined)
      url_ +=
        "tenantExternalId=" + encodeURIComponent("" + tenantExternalId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetSites(_response);
      });
  }

  protected processGetSites(response: Response): Promise<SiteResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <SiteResponse[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<SiteResponse[]>(<any>null);
  }

  /**
   * Get all properties for logged-in tenant
   * @return Success
   */
  getProperties(): Promise<PropertyListResponse[]> {
    let url_ = this.baseUrl + "/api/Property";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetProperties(_response);
      });
  }

  protected processGetProperties(
    response: Response,
  ): Promise<PropertyListResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <PropertyListResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<PropertyListResponse[]>(<any>null);
  }

  /**
   * Map a site
   * @param body (optional) site info
   * @return Success
   */
  postSite(
    body: RegisterSiteRequest | undefined,
  ): Promise<RegisterSiteResponse> {
    let url_ = this.baseUrl + "/api/Sites";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPostSite(_response);
      });
  }

  protected processPostSite(response: Response): Promise<RegisterSiteResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <RegisterSiteResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<RegisterSiteResponse>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateSite(
    id: string,
    body: UpdateSiteRequest | undefined,
  ): Promise<SiteResponse> {
    let url_ = this.baseUrl + "/api/Sites/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateSite(_response);
      });
  }

  protected processUpdateSite(response: Response): Promise<SiteResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <SiteResponse>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<SiteResponse>(<any>null);
  }

  /**
   * Delete a site
   * @param id id of site
   * @return Success
   */
  deleteSite(id: string): Promise<void> {
    let url_ = this.baseUrl + "/api/Sites/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "DELETE",
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteSite(_response);
      });
  }

  protected processDeleteSite(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * @return Success
   */
  locksSync(id: string): Promise<string> {
    let url_ = this.baseUrl + "/api/Sites/{id}/locks/sync";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processLocksSync(_response);
      });
  }

  acgSync(id: string): Promise<string> {
    let url_ = this.baseUrl + "/api/Sites/{id}/sync?flags=Units";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processLocksSync(_response);
      });
  }

  protected processLocksSync(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <string>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<string>(<any>null);
  }

  syncPreview(id: string, flags: number): Promise<SyncChangesetPreview> {
    let url_ = this.baseUrl + "/api/Sites/{id}/sync/preview?flags={flags}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace("{flags}", encodeURIComponent("" + flags));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSyncPreview(_response);
      });
  }

  protected processSyncPreview(response: Response): Promise<SyncChangesetPreview> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return _responseText === ""
          ? <SyncChangesetPreview><unknown>null
          : <SyncChangesetPreview>JSON.parse(_responseText, this.jsonParseReviver);
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<SyncChangesetPreview>(<any>null);
  }

  importInventory(id: string, inventory: ImportInventoryRequest): Promise<BatchLockUploadResponse> {
    let url_ = this.baseUrl + "/api/Sites/{id}/import";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(inventory);
    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => this.http.fetch(url_, transformedOptions_))
      .then((_response: Response) => this.processImportInventory(_response));
  }

  protected processImportInventory(response: Response): Promise<BatchLockUploadResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach)
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    if (status === 200) {
      return response.text().then((_responseText) =>
        _responseText === ""
          ? <BatchLockUploadResponse><unknown>null
          : <BatchLockUploadResponse>JSON.parse(_responseText, this.jsonParseReviver)
      );
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) =>
        throwException("An unexpected server error occurred.", status, _responseText, _headers)
      );
    }
    return Promise.resolve<BatchLockUploadResponse>(<any>null);
  }

  importPreview(id: string, inventory: ImportInventoryRequest): Promise<SyncChangesetPreview> {
    let url_ = this.baseUrl + "/api/Sites/{id}/import/preview";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(inventory);
    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => this.http.fetch(url_, transformedOptions_))
      .then((_response: Response) => this.processImportPreview(_response));
  }

  protected processImportPreview(response: Response): Promise<SyncChangesetPreview> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach)
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    if (status === 200) {
      return response.text().then((_responseText) =>
        _responseText === ""
          ? <SyncChangesetPreview><unknown>null
          : <SyncChangesetPreview>JSON.parse(_responseText, this.jsonParseReviver)
      );
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) =>
        throwException("An unexpected server error occurred.", status, _responseText, _headers)
      );
    }
    return Promise.resolve<SyncChangesetPreview>(<any>null);
  }

  parseCsv(id: string, file: File): Promise<CsvParseResult> {
    let url_ = this.baseUrl + "/api/Sites/{id}/import/parse-csv";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const formData = new FormData();
    formData.append("file", file, file.name);

    let options_ = <RequestInit>{
      body: formData,
      method: "POST",
      headers: { Accept: "application/json" },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => this.http.fetch(url_, transformedOptions_))
      .then((_response: Response) => this.processParseCsv(_response));
  }

  protected processParseCsv(response: Response): Promise<CsvParseResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach)
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    if (status === 200) {
      return response.text().then((_responseText) =>
        _responseText === ""
          ? <CsvParseResult><unknown>null
          : <CsvParseResult>JSON.parse(_responseText, this.jsonParseReviver)
      );
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) =>
        throwException("An unexpected server error occurred.", status, _responseText, _headers)
      );
    }
    return Promise.resolve<CsvParseResult>(<any>null);
  }

  /**
   * @return Success
   */
  getOperators(id: string): Promise<OperatorResponse[]> {
    let url_ = this.baseUrl + "/api/Sites/{id}/operators";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetOperators(_response);
      });
  }

  protected processGetOperators(
    response: Response,
  ): Promise<OperatorResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <OperatorResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<OperatorResponse[]>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  registerOperator(
    id: string,
    body: RegisterOperatorRequest | undefined,
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/Sites/{id}/operators";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processRegisterOperator(_response);
      });
  }

  protected processRegisterOperator(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <string>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<string>(<any>null);
  }

  /**
   * @return Success
   */
  deleteOperator(id: string, operatorId: number): Promise<string> {
    let url_ = this.baseUrl + "/api/Sites/{id}/operators/{operatorId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (operatorId === undefined || operatorId === null)
      throw new Error("The parameter 'operatorId' must be defined.");
    url_ = url_.replace("{operatorId}", encodeURIComponent("" + operatorId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "DELETE",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteOperator(_response);
      });
  }

  protected processDeleteOperator(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <string>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<string>(<any>null);
  }

  /**
   * @param skip (optional)
   * @param take (optional)
   * @return Success
   */
  getPhysicalKeys(
    id: string,
    skip: number | undefined,
    take: number | undefined,
  ): Promise<PhysicalKeyResponse[]> {
    let url_ = this.baseUrl + "/api/Sites/{id}/physicalKeys?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (skip === null) throw new Error("The parameter 'skip' cannot be null.");
    else if (skip !== undefined)
      url_ += "skip=" + encodeURIComponent("" + skip) + "&";
    if (take === null) throw new Error("The parameter 'take' cannot be null.");
    else if (take !== undefined)
      url_ += "take=" + encodeURIComponent("" + take) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetPhysicalKeys(_response);
      });
  }

  protected processGetPhysicalKeys(
    response: Response,
  ): Promise<PhysicalKeyResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <PhysicalKeyResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<PhysicalKeyResponse[]>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addPhysicalKey(
    id: string,
    body: PhysicalKeyRequest | undefined,
  ): Promise<PhysicalKeyResponse> {
    let url_ = this.baseUrl + "/api/Sites/{id}/physicalKeys";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAddPhysicalKey(_response);
      });
  }

  protected processAddPhysicalKey(
    response: Response,
  ): Promise<PhysicalKeyResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        result201 =
          _responseText === ""
            ? null
            : <PhysicalKeyResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result201;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<PhysicalKeyResponse>(<any>null);
  }

  /**
   * @return Success
   */
  getPhysicalKey(id: string, credential: string): Promise<PhysicalKeyResponse> {
    let url_ = this.baseUrl + "/api/Sites/{id}/physicalKeys/{credential}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (credential === undefined || credential === null)
      throw new Error("The parameter 'credential' must be defined.");
    url_ = url_.replace("{credential}", encodeURIComponent("" + credential));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetPhysicalKey(_response);
      });
  }

  protected processGetPhysicalKey(
    response: Response,
  ): Promise<PhysicalKeyResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <PhysicalKeyResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<PhysicalKeyResponse>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updatePhysicalKey(
    id: string,
    credential: string,
    body: PhysicalKeyUpdateRequest | undefined,
  ): Promise<PhysicalKeyResponse> {
    let url_ = this.baseUrl + "/api/Sites/{id}/physicalKeys/{credential}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (credential === undefined || credential === null)
      throw new Error("The parameter 'credential' must be defined.");
    url_ = url_.replace("{credential}", encodeURIComponent("" + credential));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdatePhysicalKey(_response);
      });
  }

  protected processUpdatePhysicalKey(
    response: Response,
  ): Promise<PhysicalKeyResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        result201 =
          _responseText === ""
            ? null
            : <PhysicalKeyResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result201;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<PhysicalKeyResponse>(<any>null);
  }

  /**
   * @return Success
   */
  deletePhysicalKey(id: string, credential: string): Promise<any> {
    let url_ = this.baseUrl + "/api/Sites/{id}/physicalKeys/{credential}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (credential === undefined || credential === null)
      throw new Error("The parameter 'credential' must be defined.");
    url_ = url_.replace("{credential}", encodeURIComponent("" + credential));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "DELETE",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeletePhysicalKey(_response);
      });
  }

  protected processDeletePhysicalKey(response: Response): Promise<any> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <any>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<any>(<any>null);
  }

  /**
   * @return Success
   */
  markPhysicalKeyEncoded(id: string, credential: string): Promise<any> {
    let url_ =
      this.baseUrl + "/api/Sites/{id}/physicalKeys/{credential}/encoded";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (credential === undefined || credential === null)
      throw new Error("The parameter 'credential' must be defined.");
    url_ = url_.replace("{credential}", encodeURIComponent("" + credential));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "POST",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processMarkPhysicalKeyEncoded(_response);
      });
  }

  protected processMarkPhysicalKeyEncoded(response: Response): Promise<any> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <any>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<any>(<any>null);
  }

  /**
   * @param skip (optional)
   * @param take (optional)
   * @param sortDirection (optional)
   * @param sortProperty (optional)
   * @param filterOperation (optional)
   * @param filterProperty (optional)
   * @param filterValue (optional)
   * @return Success
   */
  getSiteGuests(
    id: string,
    skip: number | undefined,
    take: number | undefined,
    sortDirection: ListSortDirection | undefined,
    sortProperty: SiteGuestProperty | undefined,
    filterOperation: FilterOperation | undefined,
    filterProperty: SiteGuestProperty | undefined,
    filterValue: string | undefined,
  ): Promise<GuestResponse[]> {
    let url_ = this.baseUrl + "/api/Sites/{id}/guests?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (skip === null) throw new Error("The parameter 'skip' cannot be null.");
    else if (skip !== undefined)
      url_ += "skip=" + encodeURIComponent("" + skip) + "&";
    if (take === null) throw new Error("The parameter 'take' cannot be null.");
    else if (take !== undefined)
      url_ += "take=" + encodeURIComponent("" + take) + "&";
    if (sortDirection === null)
      throw new Error("The parameter 'sortDirection' cannot be null.");
    else if (sortDirection !== undefined)
      url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
    if (sortProperty === null)
      throw new Error("The parameter 'sortProperty' cannot be null.");
    else if (sortProperty !== undefined)
      url_ += "sortProperty=" + encodeURIComponent("" + sortProperty) + "&";
    if (filterOperation === null)
      throw new Error("The parameter 'filterOperation' cannot be null.");
    else if (filterOperation !== undefined)
      url_ +=
        "filterOperation=" + encodeURIComponent("" + filterOperation) + "&";
    if (filterProperty === null)
      throw new Error("The parameter 'filterProperty' cannot be null.");
    else if (filterProperty !== undefined)
      url_ += "filterProperty=" + encodeURIComponent("" + filterProperty) + "&";
    if (filterValue === null)
      throw new Error("The parameter 'filterValue' cannot be null.");
    else if (filterValue !== undefined)
      url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetSiteGuests(_response);
      });
  }

  protected processGetSiteGuests(response: Response): Promise<GuestResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <GuestResponse[]>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<GuestResponse[]>(<any>null);
  }

  /**
   * @return Success
   */
  getSiteGuest(id: string, guestId: string): Promise<GuestResponse> {
    let url_ = this.baseUrl + "/api/Sites/{id}/guests/{guestId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (guestId === undefined || guestId === null)
      throw new Error("The parameter 'guestId' must be defined.");
    url_ = url_.replace("{guestId}", encodeURIComponent("" + guestId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetSiteGuest(_response);
      });
  }

  protected processGetSiteGuest(response: Response): Promise<GuestResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <GuestResponse>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<GuestResponse>(<any>null);
  }

  /**
   * @return Success
   */
  getGuestPhysicalKeys(
    id: string,
    guestId: string,
  ): Promise<PhysicalKeyResponse[]> {
    let url_ = this.baseUrl + "/api/Sites/{id}/guests/{guestId}/physicalKeys";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (guestId === undefined || guestId === null)
      throw new Error("The parameter 'guestId' must be defined.");
    url_ = url_.replace("{guestId}", encodeURIComponent("" + guestId));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetGuestPhysicalKeys(_response);
      });
  }

  protected processGetGuestPhysicalKeys(
    response: Response,
  ): Promise<PhysicalKeyResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <PhysicalKeyResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<PhysicalKeyResponse[]>(<any>null);
  }

  /**
   * @return Success
   */
  getAccessSchedules(id: string): Promise<AccessScheduleResponse[]> {
    let url_ = this.baseUrl + "/api/Sites/{id}/accessschedules";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetAccessSchedules(_response);
      });
  }

  protected processGetAccessSchedules(
    response: Response,
  ): Promise<AccessScheduleResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <AccessScheduleResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<AccessScheduleResponse[]>(<any>null);
  }

  /**
   * @return Success
   */
  deleteAccessSchedule(siteId: string, id: string): Promise<any> {
    let url_ = this.baseUrl + "/api/Sites/{siteId}/accessschedules/{id}";
    if (siteId === undefined || siteId === null)
      throw new Error("The parameter 'siteId' must be defined.");
    url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "DELETE",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteAccessSchedule(_response);
      });
  }

  protected processDeleteAccessSchedule(response: Response): Promise<any> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <any>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<any>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  updateAccessSchedule(
    siteId: string,
    id: string,
    body: AccessScheduleRequest | undefined,
  ): Promise<AccessScheduleResponse> {
    let url_ = this.baseUrl + "/api/Sites/{siteId}/accessschedules/{id}";
    if (siteId === undefined || siteId === null)
      throw new Error("The parameter 'siteId' must be defined.");
    url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUpdateAccessSchedule(_response);
      });
  }

  protected processUpdateAccessSchedule(
    response: Response,
  ): Promise<AccessScheduleResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <AccessScheduleResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<AccessScheduleResponse>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  addAccessSchedule(
    siteId: string,
    body: AccessScheduleRequest | undefined,
  ): Promise<AccessScheduleResponse> {
    let url_ = this.baseUrl + "/api/Sites/{siteId}/accessschedules";
    if (siteId === undefined || siteId === null)
      throw new Error("The parameter 'siteId' must be defined.");
    url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAddAccessSchedule(_response);
      });
  }

  protected processAddAccessSchedule(
    response: Response,
  ): Promise<AccessScheduleResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        result201 =
          _responseText === ""
            ? null
            : <AccessScheduleResponse>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result201;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<AccessScheduleResponse>(<any>null);
  }

  /**
   * @return Success
   */
  getLockFirmwareByDeviceType(
    id: string,
    deviceType: string,
  ): Promise<LockAvailableFirmwareResponse[]> {
    let url_ = this.baseUrl + "/api/Sites/{id}/{deviceType}/firmware";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (deviceType === undefined || deviceType === null)
      throw new Error("The parameter 'deviceType' must be defined.");
    url_ = url_.replace("{deviceType}", encodeURIComponent("" + deviceType));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetLockFirmwareByDeviceType(_response);
      });
  }

  protected processGetLockFirmwareByDeviceType(
    response: Response,
  ): Promise<LockAvailableFirmwareResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <LockAvailableFirmwareResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<LockAvailableFirmwareResponse[]>(<any>null);
  }

  /**
   * Get site users for logged-in tenant
   * @param page (optional) pagination page
   * @param pageSize (optional) pagination pageSize
   * @param searchString (optional) pagination searchString
   * @param tenantExternalId (optional) tenant unique name, e.g. Livly
   * @return Success
   */
  getSiteUsers(
    page: number | undefined,
    pageSize: number | undefined,
    searchString: string | undefined,
    tenantExternalId: string | undefined,
  ): Promise<SiteUserResponse[]> {
    let url_ = this.baseUrl + "/api/SiteUsers?";
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined)
      url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (searchString === null)
      throw new Error("The parameter 'searchString' cannot be null.");
    else if (searchString !== undefined)
      url_ += "searchString=" + encodeURIComponent("" + searchString) + "&";
    if (tenantExternalId === null)
      throw new Error("The parameter 'tenantExternalId' cannot be null.");
    else if (tenantExternalId !== undefined)
      url_ +=
        "tenantExternalId=" + encodeURIComponent("" + tenantExternalId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetSiteUsers(_response);
      });
  }

  protected processGetSiteUsers(
    response: Response,
  ): Promise<SiteUserResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <SiteUserResponse[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<SiteUserResponse[]>(<any>null);
  }

  /**
   * Add a site user
   * @param body (optional) user info
   * @return Success
   */
  postSiteUser(
    body: RegisterSiteUserRequest | undefined,
  ): Promise<RegisterSiteUserRequest> {
    let url_ = this.baseUrl + "/api/SiteUsers";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPostSiteUser(_response);
      });
  }

  protected processPostSiteUser(
    response: Response,
  ): Promise<RegisterSiteUserRequest> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <RegisterSiteUserRequest>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<RegisterSiteUserRequest>(<any>null);
  }

  /**
   * Register user for Assa mobile keys (creates Assa "endPoint" and "invite code")
   * @param body (optional) invite information
   * @return Success
   */
  postSiteUserAssa(
    body: InviteAssaUserRequest | undefined,
  ): Promise<InviteResponse> {
    let url_ = this.baseUrl + "/api/SiteUsers/assa";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPostSiteUserAssa(_response);
      });
  }

  protected processPostSiteUserAssa(
    response: Response,
  ): Promise<InviteResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <InviteResponse>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<InviteResponse>(<any>null);
  }

  /**
   * map an OpenPath site user
   * @param body (optional) user info
   * @return Success
   */
  postSiteUserOpenPath(
    body: RegisterOpenPathUserRequest | undefined,
  ): Promise<RegisterOpenPathUserRequest> {
    let url_ = this.baseUrl + "/api/SiteUsers/openpath";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPostSiteUserOpenPath(_response);
      });
  }

  protected processPostSiteUserOpenPath(
    response: Response,
  ): Promise<RegisterOpenPathUserRequest> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <RegisterOpenPathUserRequest>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<RegisterOpenPathUserRequest>(<any>null);
  }

  /**
   * map a Butterfly site user
   * @param body (optional) user info
   * @return Success
   */
  postSiteUserButterfly(
    body: RegisterButterflyUserRequest | undefined,
  ): Promise<RegisterButterflyUserRequest> {
    let url_ = this.baseUrl + "/api/SiteUsers/butterfly";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPostSiteUserButterfly(_response);
      });
  }

  protected processPostSiteUserButterfly(
    response: Response,
  ): Promise<RegisterButterflyUserRequest> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <RegisterButterflyUserRequest>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<RegisterButterflyUserRequest>(<any>null);
  }

  /**
   * Delete a site user
   * @param id id of site user
   * @return Success
   */
  deleteSiteUser(id: string): Promise<void> {
    let url_ = this.baseUrl + "/api/SiteUsers/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "DELETE",
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteSiteUser(_response);
      });
  }

  protected processDeleteSiteUser(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Register client
   * @param body (optional) client information
   * @return Success
   */
  postTenant(body: RegisterTenantRequest | undefined): Promise<TenantResponse> {
    let url_ = this.baseUrl + "/api/Tenants";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPostTenant(_response);
      });
  }

  protected processPostTenant(response: Response): Promise<TenantResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <TenantResponse>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<TenantResponse>(<any>null);
  }

  /**
   * Delete a tenant
   * @param id id of tenant
   * @return Success
   */
  deleteTenant(id: string): Promise<void> {
    let url_ = this.baseUrl + "/api/Tenants/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <RequestInit>{
      method: "DELETE",
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processDeleteTenant(_response);
      });
  }

  protected processDeleteTenant(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Get client token
   * @param body (optional)
   * @return Success
   */
  getToken(body: ClientTokenRequest | undefined): Promise<string> {
    let url_ = this.baseUrl + "/api/Token";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_ = <RequestInit>{
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "application/json",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processGetToken(_response);
      });
  }

  protected processGetToken(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ""
            ? null
            : <string>JSON.parse(_responseText, this.jsonParseReviver);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          "An unexpected server error occurred.",
          status,
          _responseText,
          _headers,
        );
      });
    }
    return Promise.resolve<string>(<any>null);
  }
}

export enum AccessControlDoorType {
  Guest = "guest",
  Common = "common",
  Door = "door",
  Zone = "zone",
  Group = "group",
  Output = "output",
  Function = "function",
  Location = "location",
}

export interface AccessControlGroupLockResponse {
  lock?: LockResponse;
}

export interface AccessControlGroupResponse {
  id?: string;
  externalId?: string | undefined;
  propertyExternalId?: string | undefined;
  unitNumber?: string | undefined;
  type?: AccessControlGroupType;
  name?: string | undefined;
  description?: string | undefined;
  createdTimestamp?: Date;
  updatedTimestamp?: Date;
  locks?: AccessControlGroupLockResponse[] | undefined;
  tenants?: AccessControlGroupTenantResponse[] | undefined;
  noTourEnabled?: boolean | undefined;
  noTourId?: number | undefined;
  accessSchedules?: AccessScheduleResponse[] | undefined;
}

export interface AccessControlGroupTenantResponse {
  accessControlGroupId?: string;
  tenantId?: string;
  tenant?: TenantResponse;
}

export enum AccessControlGroupType {
  Regular = "regular",
  DefaultForProperty = "defaultForProperty",
  CommonDoors = "commonDoors",
  Master = "master",
  Unit = "unit",
  DefaultForGuests = "defaultForGuests",
  DefaultForStaff = "defaultForStaff",
  StaffOnly = "staffOnly",
}

export interface AccessScheduleRequest {
  time?: number;
  length?: number;
  sunday?: boolean;
  monday?: boolean;
  tuesday?: boolean;
  wednesday?: boolean;
  thursday?: boolean;
  friday?: boolean;
  saturday?: boolean;
}

export interface AccessScheduleResponse {
  id?: string;
  sunday?: boolean;
  monday?: boolean;
  tuesday?: boolean;
  wednesday?: boolean;
  thursday?: boolean;
  friday?: boolean;
  saturday?: boolean;
  time?: number;
  length?: number;
}

export interface AccountCredentialsResponse {
  id?: string;
  clientSecret?: string | undefined;
  password?: string | undefined;
  accessToken?: string | undefined;
  clientId?: string | undefined;
  username?: string | undefined;
  refreshToken?: string | undefined;
  apiUrl?: string | undefined;
  tokenUrl?: string | undefined;
}

export interface AccountResponse {
  id?: string;
  systemType?: SiteSystemType;
  tenantId?: string;
  ownerTenant?: TenantResponse;
  name?: string | undefined;
}

export interface AccountWithCredentialsResponse {
  accountCredentials?: AccountCredentialsResponse;
  id?: string;
  systemType?: SiteSystemType;
  tenantId?: string;
  ownerTenant?: TenantResponse;
  name?: string | undefined;
}

export interface BaseGuestInfo {
  guestId?: string | undefined;
}

export interface BatchRegisterLockResponse {
  numLocksUpdated?: number;
  numLocksAdded?: number;
  numFoundWithoutUpdate?: number;
}

export interface ClientTokenRequest {
  clientId: string;
  clientSecret: string;
}

export interface ConnectUserResponse {
  id?: string;
  externalId?: string | undefined;
  name?: string | undefined;
  email?: string | undefined;
  tenants?: UserTenantResponse[] | undefined;
  superUser?: boolean;
  activeTenantId?: string | undefined;
}

export interface DeviceTemporaryKeyResponse {
  deviceUniqueId?: string | undefined;
  timestamp?: Date;
  temporaryKey?: string | undefined;
  temporaryKeyVerification?: string | undefined;
}

export interface Engage {
  idToken?: string | undefined;
  accessToken?: string | undefined;
}

export enum FilterOperation {
  Contains = "Contains",
  Equals = "Equals",
  GreaterThan = "GreaterThan",
  LessThan = "LessThan",
  GreaterThanOrEqualTo = "GreaterThanOrEqualTo",
  LessThanOrEqualTo = "LessThanOrEqualTo",
}

export interface GatewayConnectedLock {
  readonly linkId?: string | undefined;
  readonly deviceId?: string | undefined;
  readonly deviceName?: string | undefined;
  readonly modelType?: string | undefined;
  readonly linkCommunicationStatus?: string | undefined;
  readonly signalQuality?: string | undefined;
  readonly batteryVoltage?: string | undefined;
}

export interface GatewayConnectedLockFirmware {
  readonly deviceId?: string | undefined;
  readonly deviceName?: string | undefined;
  readonly transferPercentage?: number;
  readonly startTime?: Date | undefined;
  readonly updateStatus?: string | undefined;
  readonly completeTime?: Date | undefined;
  readonly cancelTime?: Date | undefined;
  readonly retries?: number;
  readonly firmwareVersion?: string | undefined;
}

export interface GatewayDeviceTypeFirmware {
  readonly modelType?: string | undefined;
  readonly firmwareVersion?: string | undefined;
  readonly downloadStatus?: string | undefined;
  readonly updateStatus?: string | undefined;
  readonly connectedLockFirmware?: GatewayConnectedLockFirmware[] | undefined;
}

export interface GatewayInfoResponse {
  readonly locks?: GatewayConnectedLock[] | undefined;
  information?: GatewayInformation;
}

export interface GatewayInformation {
  readonly firmwareVersion?: string | undefined;
  readonly firmwareBootloaderVersion?: string | undefined;
  readonly firmwareBleVersion?: string | undefined;
  readonly firmwareMacAddress?: string | undefined;
  readonly firmwareEthernetMacAddress?: string | undefined;
  readonly modelType?: string | undefined;
  readonly operationalDetails?: GatewayOperationalDetails;
  readonly networkDetails?: GatewayNetworkDetails;
  readonly deviceTypeFirmware?: GatewayDeviceTypeFirmware[] | undefined;
}

export interface GatewayOperationalDetails {
  readonly deviceName?: string | undefined;
  readonly mainSerialNumber?: string | undefined;
  readonly hardwareVersion?: string | undefined;
  readonly manufacturingDate?: string | undefined;
  readonly daysInUse?: string | undefined;
  readonly upTime?: string | undefined;
  readonly gatewayRtcTime?: string | undefined;
  readonly dstEnabled?: string | undefined;
  readonly dstStart?: string | undefined;
  readonly dstEnd?: string | undefined;
}

export interface GatewayNetworkDetails {
  readonly ethernetAssignedIp?: string | undefined;
  readonly ethernetGatewayIp?: string | undefined;
  readonly ethernetNetmask?: string | undefined;
  readonly wifiAssignedIp?: string | undefined;
  readonly wifiGatewayIp?: string | undefined;
  readonly wifiNetmask?: string | undefined;
}

export interface GuestInfo {
  tenantUniqueName?: string | undefined;
  guestId?: string | undefined;
}

export interface GuestInviteByLock {
  lockId: string;
  accessToken: string;
}

export interface GuestInviteLockIdResponse {
  guestInviteId?: string;
  sortKey?: number;
  credentialType?: KeyRequestCredentialType;
  lockId?: string;
  validFrom?: Date | undefined;
  validTo?: Date | undefined;
  lock?: LockResponse;
}

export interface GuestInviteResponse {
  id?: string;
  fromInviteId?: string | undefined;
  fromGuestId?: string | undefined;
  type?: GuestInviteType;
  createdTimestamp?: Date;
  updatedTimestamp?: Date;
  guestId?: string | undefined;
  firstSite?: SiteResponse;
  connectUser?: ConnectUserResponse;
  lockIds?: GuestInviteLockIdResponse[] | undefined;
  deletedLockIds?: string | undefined;
  details?: string | undefined;
  note?: string | undefined;
  validFrom?: Date | undefined;
  validTo?: Date | undefined;
  guestFirstName?: string | undefined;
  guestLastName?: string | undefined;
}

export interface GuestInvitesRequest {
  accessToken: string;
}

export enum GuestInviteType {
  Regular = "regular",
  KeyRing = "keyRing",
}

export interface GuestKeyRequest {
  keyRequestId: string;
  credentialType: KeyRequestCredentialType;
  lockIds: string[];
  checkGuestId?: string | undefined;
  shouldNotCheckGuestId?: boolean;
}

export interface GuestKeyRequestResponse {
  keyRequestId?: string;
  tokenOrSecretInstruction?: string | undefined;
  credentialId?: string | undefined;
  engage?: Engage;
  status?: KeyRequestStatus;
}

export interface GuestResponse {
  id?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  locks?: LockResponse[] | undefined;
  accessControlGroups?: AccessControlGroupResponse[] | undefined;
  validFrom?: Date | undefined;
  validTo?: Date | undefined;
  badgeIds?: string[] | undefined;
  unitNumbers?: string[] | undefined;
}

export interface GuestTokenResponse {
  keyRequestId?: string;
  link?: string | undefined;
  tokenOrSecretInstruction?: string | undefined;
}

export interface HubScreen {
  tile1?: HubSubScreen;
  tile2?: HubSubScreen;
  tile3?: HubSubScreen;
}

export interface HubScreenRequest {
  shouldPublish?: boolean | undefined;
  hubScreen?: HubScreen;
}

export interface HubSubScreen {
  background?: TileFragmentInfo;
  subtitle?: TileFragmentInfo;
  title?: TileFragmentInfo;
  date?: TileFragmentInfo;
  time?: TileFragmentInfo;
  location?: TileFragmentInfo;
}

export interface InviteAssaUserRequest {
  phone?: string | undefined;
  siteId: string;
  connectUserExternalId: string;
  name?: string | undefined;
}

export interface InviteBackendToTenant {
  tenantExternalId: string;
  backendNameClaimId: string;
}

export interface InviteFromKeyChainRequest {
  keyRingId: string;
  checkGuestId?: string | undefined;
  shouldNotCheckGuestId?: boolean;
  guestSms?: string | undefined;
  type?: GuestInviteType;
  locks: KeyChainLock[];
  connectUserExternalId?: string | undefined;
  from?: string | undefined;
  details?: string | undefined;
  note?: string | undefined;
  guestLastName?: string | undefined;
  destinationEmail?: string | undefined;
  destinationPhone?: string | undefined;
  validFrom?: Date | undefined;
  validTo?: Date | undefined;
  pinCode?: string | undefined;
  lockSlot?: string | undefined;
}

export interface InviteResponse {
  endpointId?: string | undefined;
  invitationCode?: string | undefined;
}

export interface KeyChainLock {
  credentialType: KeyRequestCredentialType;
  lockGuid?: string;
  validFrom?: Date | undefined;
  validTo?: Date | undefined;
}

export interface KeyChainRequest {
  guestSms?: string | undefined;
  type?: GuestInviteType;
  locks: KeyChainLock[];
  connectUserExternalId?: string | undefined;
  from?: string | undefined;
  details?: string | undefined;
  note?: string | undefined;
  guestLastName?: string | undefined;
  destinationEmail?: string | undefined;
  destinationPhone?: string | undefined;
  validFrom?: Date | undefined;
  validTo?: Date | undefined;
  pinCode?: string | undefined;
  lockSlot?: string | undefined;
}

export interface KeyIssuedRequest {
  id: string;
  isVerifyingWithConnect?: boolean;
  error?: string | undefined;
  credentialId?: string | undefined;
}

export enum KeyRequestCredentialType {
  RemoteOpen = "remoteOpen",
  MobileKey = "mobileKey",
  GetPin = "getPin",
  PhysicalKey = "physicalKey",
}

export interface KeyRequestLockIdResponse {
  keyRequestId?: string;
  systemLockId?: string | undefined;
  doorType?: AccessControlDoorType;
  lock?: LockResponse;
}

export interface KeyRequestResponse {
  id?: string;
  status?: KeyRequestStatus;
  error?: string | undefined;
  credentialType?: KeyRequestCredentialType;
  credentialId?: string | undefined;
  createdTimestamp?: Date;
  updatedTimestamp?: Date;
  site?: SiteResponse;
  siteUser?: SiteUserResponse;
  connectUser?: ConnectUserResponse;
  lockIds?: KeyRequestLockIdResponse[] | undefined;
  details?: string | undefined;
  note?: string | undefined;
  validFrom?: Date | undefined;
  validTo?: Date | undefined;
  guestInvite?: GuestInviteResponse;
}

export enum KeyRequestStatus {
  Initial = "Initial",
  Approved = "Approved",
  Denied = "Denied",
  KeyIssueRequested = "KeyIssueRequested",
  KeyIssueSucceeded = "KeyIssueSucceeded",
  KeyIssueFailed = "KeyIssueFailed",
}

export enum ListSortDirection {
  Ascending = "Ascending",
  Descending = "Descending",
}

export interface LockAutomationRequest {
  time?: number;
  action: string;
  sunday?: boolean;
  monday?: boolean;
  tuesday?: boolean;
  wednesday?: boolean;
  thursday?: boolean;
  friday?: boolean;
  saturday?: boolean;
}

export interface LockAutomationResponse {
  id?: string;
  time?: number;
  action?: string | undefined;
  sunday?: boolean;
  monday?: boolean;
  tuesday?: boolean;
  wednesday?: boolean;
  thursday?: boolean;
  friday?: boolean;
  saturday?: boolean;
}

export interface LockAvailableFirmwareResponse {
  description?: string | undefined;
  deviceType?: string | undefined;
  extendedVersion?: string | undefined;
  isPublic?: boolean;
  links?: string[] | undefined;
  name?: string | undefined;
  releaseDate?: Date;
  version?: string | undefined;
}

export interface LockConfigRequestModel {
  firmwareWifi?: string | undefined;
  firmwareRecoveryVersion?: string | undefined;
  firmwareMainBl?: string | undefined;
  firmwareMain?: string | undefined;
  firmwareMacAdr?: string | undefined;
  firmwareLock?: string | undefined;
  firmwareEthernetMacAdr?: string | undefined;
  firmwareEthernetBl?: string | undefined;
  firmwareEthernet?: string | undefined;
  firmwareCredentialReader?: string | undefined;
  firmwareBLE2?: string | undefined;
  firmwareBLE?: string | undefined;
  lineVoltage?: string | undefined;
  batteryVoltage?: string | undefined;
  operatingMode?: string | undefined;
  readerSerialNumber?: string | undefined;
}

export interface LockEventModel {
  event?: string | undefined;
  time?: Date;
  readonly description?: string | undefined;
  readonly data?: string | undefined;
}

export interface LockFirmwareUpdateRequest {
  version: string;
  url: string;
  downloadTimestamp?: Date | undefined;
  implementUpdateTimestamp?: Date | undefined;
}

export interface LockHolidayRequest {
  action?: string | undefined;
  endDateTime?: Date;
  startDateTime?: Date;
}

export interface LockHolidayResponse {
  id?: string;
  action?: string | undefined;
  endDateTime?: Date;
  startDateTime?: Date;
}

export interface LockMapInfo {
  uniqueGroupName?: string | undefined;
  friendlyGroupName?: string | undefined;
  uniquePropertyName?: string | undefined;
  unitNumber?: string | undefined;
  siteId: string;
  externalId: string;
  lockFriendlyName?: string | undefined;
  credentialType: KeyRequestCredentialType;
  doorType?: AccessControlDoorType;
  systemLockId?: string | undefined;
}

export interface ChildLockSummary {
  id?: string;
  name?: string | undefined;
  systemLockId?: string | undefined;
  deviceType?: string | undefined;
  lastSeenTimeStamp?: Date | undefined;
  onlineStatus?: string | undefined;
}

export interface LockResponse {
  id?: string;
  externalId?: string | undefined;
  systemLockId?: string | undefined;
  readerSerialNumber?: string | undefined;
  doorType?: AccessControlDoorType;
  siteId?: string;
  name?: string | undefined;
  site?: SiteResponse;
  noTourId?: number | undefined;
  noTourEnabled?: boolean | undefined;
  firmwareLock?: string | undefined;
  firmwareUpdateVersion?: string | undefined;
  auditInvalidCredentials?: boolean | undefined;
  operatingMode?: string | undefined;
  lastSeenTimeStamp?: Date | undefined;
  deviceType?: string | undefined;
  onlineStatus: string | null;
  parentGatewayId?: string | undefined;
  parentGatewayName?: string | undefined;
  parentGatewaySystemLockId?: string | undefined;
  // cached gateway fields (gwe only, single-lock GET)
  firmwareMain?: string | undefined;
  firmwareBLE2?: string | undefined;
  firmwareMainBl?: string | undefined;
  firmwareMacAdr?: string | undefined;
  firmwareEthernetMacAdr?: string | undefined;
  configSyncTimestamp?: Date | undefined;
  auditSyncTimestamp?: Date | undefined;
  databaseSyncTimestamp?: Date | undefined;
  // hand-added until NSwag regeneration: when a Schlage Wi-Fi (mode 210) lock was told to next call in (UTC)
  nextDatabaseDownloadTimestamp?: Date | undefined;
  cachedChildDevices?: ChildLockSummary[] | undefined;
}

export interface LockSiteExternalIdResponse {
  systemSiteId?: string | undefined;
  siteId?: string;
}

export interface OnboardCreateInviteRequest {
  guestId: string;
  units: OnboardUnitInfo[];
  validFrom?: Date | string | undefined;
  validTo?: Date | string | undefined;
  attemptUpdatingExistingAssaEndpoints?: boolean;
  guestEmail?: string | undefined;
  guestFirstName?: string | undefined;
  guestLastName?: string | undefined;
}

export interface OnboardGroupInfo {
  groupUniqueName: string;
  name?: string | undefined;
}

export interface PropertyListResponse {
  propertyExternalId?: string | undefined;
  name?: string | undefined;
  physicalKeyExtension?: boolean | undefined;
  sites?: string[] | undefined;
  groupCount: number;
  unitCount: number;
  residentCount: number;
  staffCount: number;
}

export interface OnboardUnitInfo {
  groups?: OnboardGroupInfo[] | undefined;
  leaseId?: string | undefined;
  unitUniqueName?: string | undefined;
  buildingUniqueName: string;
  validFrom?: Date | string | undefined;
  validTo?: Date | string | undefined;
}

export interface StaffOnboardingRequest {
  guestId: string;
  validFrom?: Date | string | undefined;
  validTo?: Date | string | undefined;
  guestEmail?: string | undefined;
  guestFirstName?: string | undefined;
  guestLastName?: string | undefined;
  properties?: OnboardPropertyInfo[] | undefined;
}

export interface OnboardPropertyInfo {
  propertyExternalId?: string | undefined;
  validFrom?: Date | string | undefined;
  validTo?: Date | string | undefined;
  groups?: OnboardGroupInfo[] | undefined;
}

export interface OnboardingPreviewResponse {
  sites?: OnboardingPreviewSiteResponse[] | undefined;
}

export interface OnboardingPreviewSiteResponse {
  siteId?: string;
  siteName?: string | undefined;
  accessControlGroups?: OnboardingPreviewAccessControlGroupResponse[] | undefined;
}

export interface OnboardingPreviewAccessControlGroupResponse {
  accessControlGroupId?: string;
  name?: string | undefined;
  type?: AccessControlGroupType;
  validFrom?: Date | string | undefined;
  validTo?: Date | string | undefined;
  lockNames?: string[] | undefined;
}

export interface OperatorResponse {
  operatorId?: number;
  userName?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  role?: string | undefined;
}

export interface PhysicalKeyRequest {
  badgeId: string;
  credential: string;
  format: string;
}

export interface PhysicalKeyResponse {
  badgeId?: string | undefined;
  format?: string | undefined;
  credential?: string | undefined;
  guestId?: string | undefined;
  jaguarSectors?: string | undefined;
}

export interface PhysicalKeyUpdateRequest {
  revoked?: boolean | undefined;
  guestId?: string | undefined;
}

export interface RefreshAssaKeysRequest {
  inviteId: string;
}

export interface RegisterAccessControlGroupRequest {
  externalId?: string | undefined;
  tenantExternalId?: string | undefined;
  propertyExternalId?: string | undefined;
  unitNumber?: string | undefined;
  type?: AccessControlGroupType;
  name?: string | undefined;
  description?: string | undefined;
}

export interface RegisterAccountRequest {
  tenantExternalId: string;
  systemType: SiteSystemType;
  name: string;
  description?: string | undefined;
  clientId?: string | undefined;
  clientSecret?: string | undefined;
  clientId2?: string | undefined;
  clientSecret2?: string | undefined;
  username?: string | undefined;
  password?: string | undefined;
  accessToken?: string | undefined;
  refreshToken?: string | undefined;
  apiUrl?: string | undefined;
  tokenUrl?: string | undefined;
}

export interface RegisterAccountResponse {
  id?: string;
}

export interface RegisterAccountWithSharedCredentialsRequest {
  name: string;
  tenantExternalId: string;
  sharedAccountCredentialsId: string;
}

export interface RegisterBackendUserRequest {
  name: string;
  email: string;
  tenantExternalId: string;
  backendNameClaimId: string;
}

export interface RegisterButterflyUserRequest {
  systemUserId: string;
  siteId: string;
  connectUserExternalId: string;
  name?: string | undefined;
}

export interface RegisterConnectUserRequest {
  tenantExternalId?: string | undefined;
  email: string;
  name: string;
  role?: string | undefined;
}

export interface RegisterLockRequest {
  name: string;
  siteId: string;
  systemLockId: string;
  doorType?: AccessControlDoorType;
}

export interface RegisterLockResponse {
  id?: string;
}

export interface RegisterOpenPathUserRequest {
  credentialId: string;
  systemUserId: string;
  siteId: string;
  connectUserExternalId: string;
  name?: string | undefined;
}

export interface RegisterOperatorRequest {
  userName?: string | undefined;
  role?: string | undefined;
}

export interface RegisterScreenRequest {
  accountId: string;
  saveOnly?: boolean | undefined;
  acceptAndDeploy?: boolean | undefined;
  screenLayoutType: ScreenLayoutType;
  name: string;
  appId: string;
  description?: string | undefined;
  playerIds?: string[] | undefined;
  tileFragments?: TileFragmentInfo[] | undefined;
}

export interface RegisterScreenResponse {
  id?: string;
}

export interface RegisterSharedAccountCredentials {
  tenantExternalId?: string | undefined;
  systemType: SiteSystemType;
  name: string;
  description?: string | undefined;
  clientId?: string | undefined;
  clientSecret?: string | undefined;
  username?: string | undefined;
  password?: string | undefined;
  accessToken?: string | undefined;
  refreshToken?: string | undefined;
  apiUrl?: string | undefined;
  tokenUrl?: string | undefined;
}

export interface RegisterSiteRequest {
  accountId: string;
  name: string;
  systemSiteId: string;
  propertyExternalId?: string;
  timeZone?: string | undefined;
  proxyVersion?: number;
  accessCode?: string;
  username?: string;
  password?: string;
  sharedKey?: string;
  sharedKeyName?: string;
  systemSiteKey?: string;
}

export interface RegisterSiteResponse {
  id?: string;
}

export interface RegisterSiteUserRequest {
  systemUserId: string;
  siteId: string;
  connectUserExternalId: string;
  credentialId?: string | undefined;
}

export interface RegisterTenantRequest {
  externalId: string;
}

export interface ReplaceAssaKeysRequest {
  inviteId: string;
  siteId?: string;
  systemLockIds?: string[] | undefined;
}

export interface RevokeAssaEndpoints {
  inviteId: string;
  siteId?: string | undefined;
}

export enum ScreenChildType {
  Proposal = "Proposal",
  Version = "Version",
  Scheduled = "Scheduled",
}

export interface ScreenInviteRequest {
  validFrom?: Date | undefined;
  validTo?: Date | undefined;
  guestSms?: string | undefined;
  screenIds: string[];
  connectUserExternalId: string;
  tenantExternalId: string;
  details?: string | undefined;
  note?: string | undefined;
}

export interface ScreenInviteResponse {
  id?: string;
  createdTimestamp?: Date;
  updatedTimestamp?: Date;
  guestId?: string | undefined;
  ownerTenant?: TenantResponse;
  connectUser?: ConnectUserResponse;
  screenTiles?: ScreenInviteTileResponse[] | undefined;
  details?: string | undefined;
  validFrom?: Date | undefined;
  validTo?: Date | undefined;
  note?: string | undefined;
  inviteId?: string;
  link?: string | undefined;
}

export interface ScreenInviteTileResponse {
  screenInviteId?: string;
  screenId?: string;
  sortKey?: number;
  screen?: ScreenResponse;
}

export enum ScreenLayoutType {
  SomeTiles = "SomeTiles",
  HubScreenLayout = "HubScreenLayout",
}

export interface ScreenPlayerId {
  screenId?: string;
  playerId: string;
}

export interface ScreenResponse {
  id?: string;
  appId?: string | undefined;
  screenLayoutType?: ScreenLayoutType;
  parentScreenId?: string | undefined;
  screenChildType?: ScreenChildType;
  deployedFromScreenId?: string | undefined;
  accountId?: string;
  children?: ScreenResponse[] | undefined;
  account?: AccountResponse;
  name?: string | undefined;
  description?: string | undefined;
  playerIds?: ScreenPlayerId[] | undefined;
  tileFragments?: TileFragmentResponse[] | undefined;
  createdTimestamp?: Date;
  jsonStr?: string | undefined;
  updatedTimestamp?: Date;
}

export interface ScreenWrapper {
  screen?: ScreenResponse;
  hubScreen?: HubScreen;
}

export interface SharedAccountCredentialsResponse {
  id?: string;
  systemType?: SiteSystemType;
  name?: string | undefined;
  description?: string | undefined;
  apiUrl?: string | undefined;
  tokenUrl?: string | undefined;
  createdTimestamp?: Date;
  updatedTimestamp?: Date;
  accounts?: AccountResponse[] | undefined;
  tenants?: SharedCredentialsTenantResponse[] | undefined;
}

export interface SharedCredentialsTenantResponse {
  tenantId?: string;
  sharedAccountCredentialsId?: string;
  tenant?: TenantResponse;
}

export interface SimpleKeyRequest {
  credentialType: KeyRequestCredentialType;
  guestSms?: string | undefined;
  lockIds: string[];
  siteId?: string | undefined;
  systemLockIds: string[];
  connectUserExternalId: string;
  details?: string | undefined;
  note?: string | undefined;
  destinationEmail?: string | undefined;
  destinationPhone?: string | undefined;
  validFrom?: Date | undefined;
  validTo?: Date | undefined;
  pinCode?: string | undefined;
  lockSlot?: string | undefined;
}

export enum SiteGuestProperty {
  FirstName = "FirstName",
  LastName = "LastName",
  ValidTo = "ValidTo",
  ValidFrom = "ValidFrom",
  BadgeId = "BadgeId",
  UnitNumber = "UnitNumber",
}

export interface SiteResponse {
  id?: string;
  systemSiteId?: string | undefined;
  name?: string | undefined;
  account?: AccountResponse;
  timeZone?: string | undefined;
}

export enum SiteSystemType {
  Assa = "Assa",
  Openpath = "Openpath",
  Brivo = "Brivo",
  Butterfly = "Butterfly",
  SmartThings = "SmartThings",
  Buzzly = "Buzzly",
  LivlySms = "LivlySms",
  LivlyDigital = "LivlyDigital",
  Stratis = "Stratis",
  SaltoSpace = "SaltoSpace",
  SchlageEngage = "SchlageEngage",
  DormaKaba = "Dormakaba",
}

export interface SiteUserResponse {
  id?: string;
  siteId?: string;
  site?: SiteResponse;
  user?: ConnectUserResponse;
  systemUserId?: string | undefined;
  credentialId?: string | undefined;
}

export interface TenantResponse {
  id?: string;
  externalId?: string | undefined;
  name?: string | undefined;
}

export interface TileFragmentInfo {
  description?: string | undefined;
  text?: string | undefined;
  imageUrl?: string | undefined;
  imagePublicId?: string | undefined;
  minImageWidth?: number | undefined;
  minImageHeight?: number | undefined;
}

export interface TileFragmentResponse {
  id?: string;
  name?: string | undefined;
  text?: string | undefined;
  description?: string | undefined;
  imagePublicId?: string | undefined;
  imageUrl?: string | undefined;
  minImageWidth?: number | undefined;
  minImageHeight?: number | undefined;
}

export interface UpdateAccessControlGroupRequest {
  externalId?: string | undefined;
  propertyExternalId?: string | undefined;
  unitNumber?: string | undefined;
  type?: AccessControlGroupType;
  name?: string | undefined;
  description?: string | undefined;
  noTourEnabled?: boolean;
}

export interface UpdateLockRequest {
  doorType?: AccessControlDoorType;
  name?: string | undefined;
  noTourEnabled?: boolean;
}

export interface UpdateScreenFromInvite {
  screenInviteId: string;
  screenId: string;
  accessToken: string;
  updateRequest: RegisterScreenRequest;
  checkGuestId?: string | undefined;
  shouldNotCheckGuestId?: boolean;
}

export interface UpdateSiteRequest {
  name?: string | undefined;
  timeZone?: string | undefined;
}

export interface UserTenantResponse {
  role?: string | undefined;
  tenantId?: string;
  connectUserId?: string;
  tenant?: TenantResponse;
}

export interface FileParameter {
  data: any;
  fileName: string;
}

export interface SyncChangesetPreview {
  locks: LockChangePreview[];
  groups: GroupChangePreview[];
  unitAcgMatches: UnitAcgMatchPreview[];
  warning?: string;
}

export interface LockChangePreview {
  systemLockId: string;
  name: string;
  /** "Added" | "Removed" | "Updated" */
  action: string;
  /** Populated when action == "Updated": e.g. ["Name: 'Old' → 'New'"] */
  changes: string[];
}

export interface GroupChangePreview {
  systemGroupId: string;
  name: string;
  /** "Added" | "Removed" | "Updated" */
  action: string;
  locksAdded: string[];
  locksRemoved: string[];
}

export interface UnitAcgMatchPreview {
  /** Lock that would be matched */
  lockName: string;
  /** Unit ACG it would be assigned to. Ends with " (new)" if the ACG doesn't exist yet. */
  acgName: string;
}

export interface ImportInventoryRequest {
  locks: ImportLockRow[];
  /** Required when site has multiple properties. Identifies which property to use for unit ACG operations. */
  propertyExternalId?: string;
  /** Optional override for unit ACG name prefix. Defaults to the site name. */
  propertyNameOverride?: string;
  /** When false, existing locks not in the import will be removed. Default: true (additive). */
  additive?: boolean;
}

export interface ImportLockRow {
  systemLockId: string;
  name: string;
  doorType: string;
  unitNumber?: string;
  externalId?: string;
  deviceType?: string;
  systemSecondaryId?: string;
}

export interface BatchLockUploadResponse {
  locksCreated: number;
  acgsCreated: number;
  locksAddedToAcgs: number;
}

export interface CsvParseResult {
  /** The parsed inventory, ready to submit to /import or /import/preview. */
  inventory: ImportInventoryRequest;
  /** Total non-empty data rows (header row excluded when detected). */
  rowCount: number;
  /** Rows that could not be parsed (invalid DoorType, missing fields, etc.). */
  errors: string[];
  /** True when the first row was identified as column headers; columns may be in any order. */
  headersDetected: boolean;
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any,
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any,
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}
